import { assetQueue } from './asset_queue_install' // 一番最初に: 絵と音を読む順番 (11-02・src/asset_queue.ts)
import './steam_storage'
import { setKnockSkid } from './exec_knock_skid'
import { loadUiFont, setUiFont } from './ui_font'
import { setStepWeight } from './exec_step_weight'
import { setWallHuntGame, setWallHuntAim, setWallHuntSpirits, setWallHuntSpiritTiming, setWallHuntLeap } from './awoken_wall_hunt_game'
import { setWallDashFix, wallDashFix } from './awoken_wall_dash_fix'
import { setRampageSpiritHold } from './awoken_rampage_v5'
// エントリポイント。
// Phase 4: localStorage からキャンペーンを復元、初期化時に流し込む。

import { FIXED_DT, ARENA, EXECUTE, COMBAT, PLAYER, arenaBoundsFor, BOSS_BODY_WALL_INSET_PX, setAwokenWallInsetTrial, setHoundWallInsetTrial, setBrideWallInsetTrial, setKnightWallInsetTrial, getCameraMarginPx, setArenaWidthMul, setCameraMarginPx, worldBoundsFor } from './balance'
import { createInitialState, createCampaign, createSoloState, setSoloDifficulty, SOLO_DIFFICULTY, withBossIntroDone } from './state'
import { updateGame, setDebugSoloAttack } from './game'
import { CAM_ZOOM_DEFAULT, camZoomFit, camZoomView, cycleCamZoom, readCamZoomFromUrl, setCamZoom, setCamZoomScene } from './cam_zoom'
import { compensateShadowBlur, readRenderScaleFromUrl, renderScale } from './render_scale'
import { syncAwokenWideStage } from './awoken_wide_stage'
import { SMEAR_ARTS, titleBootLampDrawnLastFrame, flashbackImagesSettled, roomBackgroundSettled, prefetchFlashbackImages, prefetchRoomBackground, prefetchTipsArt, draw, measureAdvChoiceRectsForInput, setAuraBodyPose, setBossFootLiftOverride, setBossHeightRatioOverride, setCameraEnabled, setCannonShotLook, bossDisplayHeightFor, useAwokenOldRoom, useAwokenRoomSlide, useRoosterOldRoom } from './render'
import { setQuakeLook } from './quake_fx'
import { setFajinLook, setFajinTint, type FajinLook } from './fajin_fx'
import { hasBufferedAction, initInput, readInput, setInputBufferAgingFrozen, setInputUiMode, type InputAction } from './input'
const EXEC_SLOW_CUT_ACTIONS: readonly InputAction[] = ['attack', 'parry', 'step']
import { ensureAudio, setAdvAmbience, setBgmMix, playBgmPath, bgmPathForBoss, setBgmRate, playPending, retryBgmStart, fadeOutBgm, playSting, preloadParrySteel, preloadSfxSamples, preloadKnightSweepCandidates, preloadKnightTellCandidates, preloadParrySoundCandidates, preloadParryPitchSamples, preloadParryRemakeSamples, __devPlayParry, playSfx, setExecWorldColors, setSoulVoice, setSoulTake, __devCaptureStream, preloadLunaFinisherSfx, preloadLunaAliceSfx } from './audio'
import { finisherV2On } from './luna_finisher'
import { aliceClockMs, lunaExecSwapOn } from './luna_exec_swap'
import { setSfxRootsDev } from './audio'
import { loadCampaign, loadRecord, setSenshurakuGateOverride, isSenshurakuOpen } from './persistence'
import { syncAchievementsToSteam } from './achievements'
import { useRoosterFight, setRoosterParryPostureMul } from './rooster_fight'
import { setRoosterHopMove } from './rooster_hop_move'
import { setTwinsPlanA, setTwinsRevealHold, setTwinsRevealLook, useTwinsFight } from './twins_fight'
import { preloadBossSprites, warmBossSpriteMeta, bossSpritesSettled, initBossSpriteRuntime, clearBossSpriteCache, setSpriteFileOverride, measureBossCoreBands, setParriedPoseTrial, parseParriedPoseTrial } from './sprites'
import { heavyLungeTravelPx } from './player_attack_frames'
import { setPlayerComboEnabled } from './player_combo_switch'
import { applyPostureHoldLook } from './tut_focus'
import { setRoosterFeather, setRoosterFx } from './rooster_fx'
import { setLampMoteLook } from './lamp_mote'
import { setLampLightLook } from './lamp_light'
import { setLoadingLook } from './loading_indicator'
import { setCombo3rdMode, setCombo3rdLockMs, setCombo3rdBar, combo3rdPercent, combo3rdTrialInfo, setPostureHoldTip } from './player_combo3_power'
import { setAttackTempo } from './player_attack_timing'
import { setDebugSoloString, setDebugBypassStrings } from './boss'
import { setBossCore, isBossCore, setStepCooldownMs, stunPlayer } from './player'
import { execParryMode, setExecParryMode, setExecPushVersion } from './exec_parry'
import { parrySoundCandidatesWanted, setExecParrySoundVariant, setParrySoundVariant } from './parry_sound'
import { parryPitchVariant, setParryPitchVariant, type ParryPitchHit } from './parry_pitch'
import { parryRemakeVariant, parseParryByWeapon, setParryByWeapon, setParryRemakeVariant, setParryTail, PARRY_TAIL_RELEASE } from './parry_remake'
import type { ParryMaterial } from './parry_material'
import { setPushWeight } from './exec_push_weight'
import { execParryFxLabel, execSlowCutNow, execSlowTimeScale, setExecParryFx } from './exec_parry_slow_fx'
import { finishFixedStepForPresentation } from './frame_timing'
import { setBossProxyEnabled } from './boss_proxy'
import { preloadSpinePlayer, isSpinePlayerLoaded, debugSpineTrack } from './spine_player'
import { setAdvAssetsReadyCheck, setBattleAssetsReadyCheck, setFakeLoadMs } from './battle_asset_gate'
import { preloadParryFlashes, preloadFinisherFx, preloadLanceButtEruption, preloadBrideHazard, preloadRampageGrudge, preloadGrudgeOrbs, preloadFloorWave } from './fx_sprites'
import { preloadParryFamilyFx } from './parry_family_fx'
import { preloadKnightDustArt } from './knight_dust_art'
import { preloadKnightSpearTrail } from './knight_spear_trail'
import { preloadKnightSuriDust } from './knight_suri_dust'
import { getAttack, ATTACKS, setBladeHemWidth } from './attacks'
import {
  setExecutionerCannonRange, setExecutionerMortarSpread, setExecutionerCannonMode, setExecutionerCannonScore,
  setExecutionerCannonHoldMs, setExecutionerMortarRows,
} from './executioner_weapon'
import { setExecutionerSweepWindupTimeline, setExecutionerMortarRecoil, setExecutionerHolds, setExecutionerTwoKeys, type ExecutionerSweepWindupLook, setExecutionerPierceArt, setExecutionerJabArt, setAwokenBiteOrder, type AwokenBiteOrder } from './boss_pose_timeline'
import { setFajinDraw, setFajinBeat, type FajinDraw, type FajinBeat } from './executioner_fajin'
import { BOSS_DEFINITIONS, setExecutionerBladeGapMs, setBossCoreMode, type BossCoreMode } from './bosses'
import { getEndingScene, getInterludeScene, getPreBattleScene, setAdvFadeVariant, setPrincessRoom, setStayEnding, setPrologueEnabled, setPrologueSfx, setTwinsAdvArt, setTwinsAdvDraft } from './adv_scripts'
import { setAdvVoiceV2 } from './adv_voice_v2'
import { setAdvStoryFix, setAdvWordingFix } from './adv_wording_fix'
import { startScene, isPictureScene, advAmbience, ADV_BATTLE_EXIT_MS } from './adv'
import { advSceneHasFlashback, advSceneHeadSettled, preloadAdvPictures } from './adv_picture_view'
import { setEconPreset } from './econ'
import { setDemoFinalBossId, getDemoFinalBossId, createScratchCampaign, advanceToNextBoss } from './campaign'
import { nextCampaignBossId, prefetchNextEnabled } from './prefetch_next'
import { preloadBossHud } from './boss_hud_view'
import { syncFeedbackPanel, buildFeedbackContext, buildSoloFeedbackContext, readFeedbackDraft, consumeFeedbackClose, FEEDBACK_CLOSE_KEYS } from './feedback_panel'
import { getDifficulty, playerMaxPosture, parseSoloDifficulty, setHatsuenTimeRelief, playerParryActiveMs, hatsuenTimeReliefActive } from './difficulty'
import { playerStepIFrameMs } from './player_locomotion_trial'
import { setParryBreakLook } from './parry_break_fx'
import { setGuardEnabled } from './guard'
import { installPlaylog, playlogTick } from './dev_playlog'
import { playtestTick, mountRecordCopyButton } from './playtest_record'
import { installPlaytestUpload, playtestUploadTick } from './playtest_upload'
import { applyBrideShadeReachFromUrl } from './bride_shade_reach'
import { getExecAwokenReachVariant, parseExecAwokenReachVariant, setExecAwokenReachVariant } from './exec_awoken_reach'
import { parryOneMode, parseParryOneMode, setParryOneMode } from './parry_one'
import { activeDefeatTips, defeatTipsMode, eligibleDefeatTipsFor, parseDefeatTipsMode, setDefeatTipsDevProgress, setDefeatTipsMode } from './defeat_tips'
import { defeatHintMode, deathFrontMode, parseDeathFrontMode, parseDefeatHintMode, setDeathFrontMode, setDefeatHintMode } from './fresh_eyes_fix_trials'
import { parseBladePirouette, useBladeDancerPirouetteB4 } from './blade_dancer_pirouette'
import { parseBladeGamma, useBladeDancerGamma } from './blade_dancer_gamma'
import { parseBladeDelta, useBladeDancerDelta } from './blade_dancer_delta'
import { parseBladeGrandQuick, parseBladeOwnArt, parseBladeQuickArt, useBladeGammaRest, useBladeGrandQuickType, useBladeOwnArt, useBladeQuickArt } from './blade_own_art'
import { parseBladeSpin, parseBladeSpinHits, parseBladeSpinPair, parseBladeSpinTurn, setBladeSpinOldHits, setBladeSpinTurn, setBladeSpinWidePair, useBladeDancerSpin } from './blade_dancer_spin'
import { parseBladePull, useBladeDancerPull } from './blade_dancer_pull'
import { parseBladeThrow, useBladeDancerThrow } from './blade_dancer_throw'
import { BLADE_EXEC_WARM_KEYS, parseBladeArle, parseBladePullFx, useBladeDancerArle } from './blade_dancer_arle'
import { KNIGHT_EXEC_ART } from './exec_unique'
import { BLADE_FX_V2_DROPPED_SMEARS, parseBladeFx, setBladeFx } from './blade_dancer_fx_v2'
import { parseBladeFxRest, parseBladeSashWidth, setBladeFxRest } from './blade_dancer_fx_rest'
import { useBladeDancerOldArt, useBladeDancerMoveArt, useBladeDancerMotionV2, useBladeDancerMotionV3, useBladeDancerMotionV4, useBladeDancerMotionV5, useBladeDancerMotionV6, useBladeDancerWaltzV7, useBladeDancerTempoY2tz, parseBladeTrailLen } from './blade_dancer_art'
import { parseBladeTrailStop, useBladeTrailStop } from './blade_trail_stop'
import { parseBladeBodySize, useBladeBodySize } from './blade_body_size'
import { parseBladeColor, useBladeColor } from './blade_color_match'
import { parseBladeArt, useBladeArt } from './blade_art_repaint'
import { setBladeHemFx } from './blade_hem_bloom'
import { setBossWalkSurge } from './boss_walk_surge'
import { setHoundWalkLift } from './hound_walk_lift'
import { setHoundWalk8, setHoundWalk8Smooth } from './hound_walk8_1104'
import { parseBladeHemWindup, useBladeHemWindup } from './blade_hem_windup'
import { preloadSparkSprites } from './luna_spark_fx'
import type { FxEvent, GameState, SpriteKey } from './types'
import {
  DEFEAT_OVERLAY_TIMING_SEC,
  defeatRetryGateSec,
} from './defeat_overlay_timing'

const canvas = document.getElementById('game') as HTMLCanvasElement | null
if (!canvas) throw new Error('canvas#game not found')
const ctx = canvas.getContext('2d')
if (!ctx) throw new Error('2d context not available')

// 内部解像度を上げてフルスクリーン拡大時もクッキリさせる。
// 描画は ARENA(960x540) 座標前提なので、 backing を RENDER_SCALE 倍にして
// ctx を一度だけスケールする (render.ts は transform をリセットしないので基準スケールが持続)。
// 倍率は src/render_scale.ts (既定 2.6 = 案B・10-18)。 DEV は ?renderScale=2 で前の解像度に戻せる。
if (import.meta.env.DEV) readRenderScaleFromUrl(window.location.search)
const RENDER_SCALE = renderScale()
canvas.width = Math.round(ARENA.width * RENDER_SCALE)
canvas.height = Math.round(ARENA.height * RENDER_SCALE)
ctx.scale(RENDER_SCALE, RENDER_SCALE)
compensateShadowBlur(ctx)

initInput(canvas)

// 会話場面の BGM の案 (2026-10-28)。 開発版だけ ?advBgmPre=far|none ・ ?advBgmAfter=quiet|boss|amb で入れ替えて比べる。
//   far=ボスの曲を遠くに (10-28 作者が選んだ) / quiet=静かな曲を遠くに (10-28 作者が選んだ) / boss=ボスの曲を遠く遅く / amb・none=曲なし (環境音だけ)。
const advBgmParams = import.meta.env.DEV ? new URLSearchParams(window.location.search) : null
const advBgmPre: 'far' | 'none' = advBgmParams?.get('advBgmPre') === 'none' ? 'none' : 'far'
const advBgmAfter: 'quiet' | 'boss' | 'amb' = (({ quiet: 'quiet', boss: 'boss', amb: 'amb' } as const)[advBgmParams?.get('advBgmAfter') ?? ''] ?? 'quiet')
// 倒したあとの静かな曲 (2026-10-28 作者「探索の曲はチュートリアルで使っているから他の曲がいい」)。
//   ボスに当てていない曲から選ぶ。 開発版だけ ?advAfterTrack=hollow|end-true|title で入れ替えて比べる (既定 end-true＝10-28 作者「どこかのエンディングで使うわけではないならこれでお願いします」)。
const ADV_AFTER_TRACKS = { hollow: '/bgm/hollow.mp3', 'end-true': '/bgm/end-true.mp3', title: '/bgm/title.mp3' } as const
const advAfterTrack: string = ADV_AFTER_TRACKS[(advBgmParams?.get('advAfterTrack') ?? '') as keyof typeof ADV_AFTER_TRACKS] ?? ADV_AFTER_TRACKS['end-true']
// 遠くの曲の大きさ (戦いの曲を 1 とした倍率)。 会話の途中では演出のために絞らず、 場面の終わりまでこの大きさで鳴らす
//   (2026-10-28 作者「普通にゲームをプレイしている人からするとなんでここBGMないの?」)。
const ADV_BGM_FAR_LEVEL = 0.5

// フェーズ駆動 BGM (2026-06-11 一旦完成版): 各フェーズの「あるべき曲」を1箇所で決める。
//   victory/cleared/defeat はスティンガー (一発もの)、 interlude/choice は静寂 = null。
//   finisher 中は専用のスローフェード (下の finisherActive 検出) に任せるため変更しない。
function desiredBgmPath(s: GameState): string | null {
  if (!s.settings.bgmOn) return null  // BGM設定OFF
  switch (s.phase) {
    case 'title':   return '/bgm/title.mp3'
    case 'playing':
      // 先代の姫の最終部屋 (致命2回後) = 舞台仕掛けフェーズ。 曲も決闘→舞台へ転調する。
      if (s.boss.id === 'former-princess' && s.boss.executesTaken >= 2) return '/bgm/princess-stage.mp3'
      return bgmPathForBoss(s.boss.id)
    case 'ending':  return s.endingChoice === 'stay' ? '/bgm/end-stay.mp3' : '/bgm/end-loop.mp3'
    // 会話場面 (2026-10-28): 戦う前はそのボスの曲を遠くに敷き (setBgmMix)、 戦いへ抜ける時に一度消して、 戦いで頭から鳴らし直す。
    case 'preBattle': return advBgmPre === 'none' ? null : bgmPathForBoss(s.boss.id)
    case 'interlude': return advBgmAfter === 'quiet' ? advAfterTrack : advBgmAfter === 'boss' ? bgmPathForBoss(s.boss.id) : null
    default:        return null
  }
}

// BGM 再生速度 (=転調)。 1=原曲。 花嫁の最終部屋 (3部屋目) で煽りとして速く＋高くする。
//   ★実験的・戻す可能性あり (2026-06-11): この1行を 1 にすれば即無効化。 別曲ファイル不要。
//   2026-07-01: 1.12 → 1.5 (ユーザー実プレイで「BGM 倍速くらいに」 指摘)。 5-7 半音上がる転調 =
//     クライマックスの狂気・追い立て感を強化。 攻撃ペース 0.35 倍と組んで最終部屋の緊張最大化。
function desiredBgmRate(s: GameState): number {
  if (s.phase === 'interlude' && advBgmAfter === 'boss') return 0.85   // 倒したあとのボスの曲は遅く低く
  if (s.phase === 'playing' && s.boss.id === 'bride' && s.boss.executesTaken >= 2) return 1.5
  return 1
}

// 初回ユーザー操作で AudioContext と BGM を起動 (autoplay policy 対策)
const onFirstInteract = () => {
  ensureAudio()
  playBgmPath(desiredBgmPath(state))
  retryBgmStart()
}
window.addEventListener('keydown', onFirstInteract, { once: true })
window.addEventListener('pointerdown', onFirstInteract, { once: true })

// 永続化されたキャンペーンを復元してゲーム開始。
// 起動時はタイトル(操作説明)から。 任意のアクションキーで戦闘開始 (game.ts)。
// ?bossReach=old: 花嫁と亡霊の当たりの前端を 10-05 より前 (絵より最大 100px 先まで届いた値) へ戻す比較 (配布版でも読む・正本 src/bride_shade_reach.ts)。
applyBrideShadeReachFromUrl()
// ?advFade=a|b (2026-10-29): 会話の終わりにボスが光になって消える描写の案。開発版だけ。b＝青白い粒が上へ流れる (既定・10-29 作者が選んだ)・a＝銀の粒がその場で薄れる。
if (import.meta.env.DEV) setAdvFadeVariant(new URLSearchParams(window.location.search).get('advFade'))
// ?prologue=off (2026-10-29): 稽古の前のプロローグを外し、旧の3行の始まりに戻す (開発版だけ・比べる用)。
if (import.meta.env.DEV) setPrologueEnabled(new URLSearchParams(window.location.search).get('prologue') !== 'off')
// プロローグの効果音 (砂嵐・錠・吹き出し・月が回る間・紙・握り)。10-31 作者の答えで配布版の既定。開発版 ?prologueSfx=off で音なしの旧へ。
setPrologueSfx(!(import.meta.env.DEV && new URLSearchParams(window.location.search).get('prologueSfx') === 'off'))
// 軍配者たちの書き直した会話場面 (版2)。10-31 作者「全部OK」で配布版の既定。開発版 ?twinsAdv=old で前の版 (総集編) の台本へ。
setTwinsAdvDraft(!(import.meta.env.DEV && new URLSearchParams(window.location.search).get('twinsAdv') === 'old'))
// 軍配者たちの会話場面の一枚絵 8枚 (11-01)。配布版の既定。開発版 ?twinsAdvArt=off で城の一室の背景だけに戻す (&advPreview=hollow-actor で通して見られる)。
setTwinsAdvArt(!(import.meta.env.DEV && new URLSearchParams(window.location.search).get('twinsAdvArt') === 'off'))
// 会話場面の声の台詞を人物像に合わせた版 (10-31・src/adv_voice_v2.ts)。配布版の既定。開発版 ?advVoice=old で前の台詞。
if (import.meta.env.DEV) setAdvVoiceV2(new URLSearchParams(window.location.search).get('advVoice') !== 'old')
if (import.meta.env.DEV) setAdvWordingFix(new URLSearchParams(window.location.search).get('advWording') === 'fix')
if (import.meta.env.DEV) setAdvStoryFix(new URLSearchParams(window.location.search).get('advStory'))
// 千日手の軍配者たち (src/twins_fight.ts): 二人＋奥の装置の一戦。10-31 作者「今すぐ出す」で配布版の既定。開発版 &twins=old で前の総集編の版。
//   名前と部屋の数を書き換えるので、最初の state を作る前に立てる。
if (!(import.meta.env.DEV && new URLSearchParams(window.location.search).get('twins') === 'old')) useTwinsFight()
// 3部屋目の装置の現れ方の比較版 (10-31)。既定は C「上から落ちる重さ」＋溜め+1.0秒 (11-01 作者)。開発版 ?twinsReveal=old で前の「光が集まって現れる」版、&twinsRevealHold=ms で溜めを変える。
if (import.meta.env.DEV) {
  const q = new URLSearchParams(window.location.search)
  if (q.get('twinsReveal') === 'old') setTwinsRevealLook('old')
  if (q.get('twinsRevealHold') !== null) setTwinsRevealHold(Number(q.get('twinsRevealHold')))
  // 案A (11-03 作者の答え・11-04): 倒れは一時・二人倒れたら総崩れ・致命は体幹だけ・弾き返した鈴は体幹だけ。開発版 ?twinsPlanA=1 だけ。
  if (q.get('twinsPlanA') === '1') setTwinsPlanA(true)
}
// 先代の部屋の会話は「王がいるはずの部屋に先代がいた」やり取りを足した台本 B が配布版の既定 (11-01 作者)。開発版 ?princessRoom=old で前の台本 (&advPreview=former-princess で通して見られる)。
if (import.meta.env.DEV) setPrincessRoom(new URLSearchParams(window.location.search).get('princessRoom'))
// 「残る」の下書き (11-02・作者の確認待ち)。 開発版 ?stayEnding=draft で出る。 &endingPreview=stay で、 起動してすぐ「残る」の結末だけを読める (読み終えるとタイトルへ)。
if (import.meta.env.DEV) setStayEnding(new URLSearchParams(window.location.search).get('stayEnding'))
// 開発版 ?uiFont=os (11-01・src/ui_font.ts) = 前の字 (同梱の字を読まず、ゴシックだった所もゴシック)。
if (import.meta.env.DEV) setUiFont(new URLSearchParams(window.location.search).get('uiFont'))
// ?advPreview=prologue は稽古 (nameless-shade) の戦う前の場面＝プロローグを見る。
const advPreviewParam = new URLSearchParams(window.location.search).get('advPreview')
const advPreviewId = advPreviewParam === 'prologue' ? 'nameless-shade' : advPreviewParam
const advPreview = advPreviewId === 'the-executioner' || advPreviewId === 'bride' || advPreviewId === 'dream-hound' || advPreviewId === 'vigil-knight' || advPreviewId === 'blade-dancer' || advPreviewId === 'inverted-jester' || advPreviewId === 'former-princess' || advPreviewId === 'crowned-king-awoken' || advPreviewId === 'nameless-shade' || (import.meta.env.DEV && advPreviewId === 'hollow-actor')
const savedCampaign = advPreviewId ? null : loadCampaign()
// DEV ?clearMark=on|off (2026-10-09): 「終幕まで通した」印の有無を決め打ちして、 千秋楽が選べるかを確かめる。
//   on = 印あり (千秋楽が選べる) / off = 印なし (千秋楽が閉じ、 保存が千秋楽でも初演へ戻る) / 指定なし = 保存された記録のまま。
//   保存は1文字も書き換えない。 最初の state を作る前に立てる (loadSettings が読むため)。 起動後は window.__setClearMark('on'|'off'|null)
//   (もう一度「始める」を押した時から効く)。 配布版は読まず、 いつも記録を見る (src/persistence.ts isSenshurakuOpen)。
if (import.meta.env.DEV) {
  const parseClearMark = (raw: string | null): boolean | null => (raw === 'on' ? true : raw === 'off' ? false : null)
  setSenshurakuGateOverride(parseClearMark(new URLSearchParams(location.search).get('clearMark')))
  ;(window as any).__setClearMark = (v: 'on' | 'off' | null) => {
    setSenshurakuGateOverride(parseClearMark(v))
    return isSenshurakuOpen()
  }
}
let state: GameState = { ...createInitialState(savedCampaign ?? undefined), phase: 'title' }

// ===== 一戦だけモード (2026-07-28) =====
// `?fight=<bossId>` — そのボスとの戦闘だけを1本のURLで人へ渡すための入口。
//   例: https://lunaire-game.pages.dev/?fight=the-executioner
//
// ⚠️ ここは **本番ビルドに出る** = dev フックの箱 (`if (import.meta.env.DEV)`) の外に置くこと。
//   箱の中にある `?boss=` を流用すると境界が崩れ、 G キーの無敵などが配布版へ一緒に出る。
//   境界は `scripts/check_dev_leak.mjs` がビルドのたびに機械で見張っている。
//
// 知らない id を渡された時は、 黙って本編を始めない (何が起きたか分からない画面になる)。
//   タイトルのまま + console に理由を出す = 送った側が気づける。
const soloBossId = new URLSearchParams(window.location.search).get('fight')
// ヒットストップ中は押しのバッファの寿命を進めない旗。既定 = true (2026-10-12 ユーザー採用・配布版・試遊パック 10-10 の答え E-1「保つ版にする」)。
//   旧は DEV ?hitstopBuffer=off (箱の中でだけ false にする)。箱より前に宣言する (TDZ)。
let bufferAgeHeldInHitstop = true
const cannonFajinReview = import.meta.env.DEV && soloBossId === 'the-executioner'
  && new URLSearchParams(window.location.search).get('cannonFajin') === '1'
// 2026-10-21: 裾払いは板と刃の花を既定で先読み。DEV の ?bladeHemFx=now で前の見た目と比べる。
setBladeHemFx(import.meta.env.DEV ? new URLSearchParams(window.location.search).get('bladeHemFx') : null)
// 2026-11-03: ?walkSurge=1 で2枚歩き (王・覚醒獣・剣舞) の足滑りを薄める見た目の速さの波 (比較版・src/boss_walk_surge.ts)。
setBossWalkSurge(import.meta.env.DEV ? new URLSearchParams(window.location.search).get('walkSurge') : null)
// 戴冠獣の足元は歩きの時だけ 12px 上げ、技の時は 0 (2026-11-03 既定・src/hound_walk_lift.ts)。前の版 (常に 0) は ?houndLift=old。
setHoundWalkLift(import.meta.env.DEV ? new URLSearchParams(window.location.search).get('houndLift') : null)
// 戴冠獣の歩きは8コマが既定 (2026-11-04・src/hound_walk8_1104.ts)。前の2枚は開発版だけ ?houndWalk=2 で比べる。
if (import.meta.env.DEV && new URLSearchParams(window.location.search).get('houndWalk') === '2') setHoundWalk8(false)
// 8コマのカクつきの直し方の比べ物 (2026-11-04・開発版だけ ?houndWalkFix=lock|fade)。
if (import.meta.env.DEV) {
  const fix = new URLSearchParams(window.location.search).get('houndWalkFix')
  if (fix === 'lock' || fix === 'fade') setHoundWalk8Smooth(fix)
}
// ?footLift=<0..12>: 介錯の足元の持ち上げ (BOSS_FOOT_LIFT・既定 6。?fight=dream-hound と組むと四つ足の王・既定 0) を実プレイで見比べる用のつまみ (2026-09-02 見た目の棚卸し §C3)。
//   0 = 旧 (靴底が床の線より 12px 下) / 12 = 主人公と同じ線。0 を含むので「パラメータの実在」を先に確かめる (src/game.ts の setGreed と同じ罠)。
if (import.meta.env.DEV) {
  // ?comboTrial=0: 主人公の連撃を切って旧の1段で見比べる。配布版は入 (10-02 夜 ユーザー「3段は配布版で一旦有効にしていい」)。
  if (new URLSearchParams(location.search).get('comboTrial') === '0') setPlayerComboEnabled(false)
  // ?combo3rd=<百分率>: 連撃3段目 (重い締め) の命中の体力ダメージと体幹ダメージに掛ける倍率の比較版 (2026-10-09・src/player_combo3_power.ts)。
  //   指定なし・100 = 今のまま (全段同じ・配布版)。150 = 1:1:1.5。範囲は 50〜400 (外は無視)。window.__combo3rd() でいま効いている百分率を返す。
  //   3段目の通常命中でボスの体幹の戻りを止める (量は 100% のまま・2026-10-12 から配布版の既定 = 入・1800ms・&combo3rdLockMs=<300..10000> で替える)。
  //   ?combo3rd=off: 旧へ戻す = 3段目の得なし (体幹の戻りは普段の猶予のまま・稽古も旧の並び)。?combo3rd=lock は既定と同じ。
  //   &combo3rdBar=1 (開発版のまま・配布版には入れない): 3段目で削った分だけ、体力と体幹の帯に白い残りが一拍残る。
  //   window.__combo3rdTrial() = いま効いている { percent, lockMs (0=切), bar }。記録 = docs/research/2026-10-12-combo3-ship-and-tut-assist.md。
  setCombo3rdMode(new URLSearchParams(location.search).get('combo3rd'))
  setCombo3rdLockMs(new URLSearchParams(location.search).get('combo3rdLockMs'))
  setCombo3rdBar(new URLSearchParams(location.search).get('combo3rdBar') === '1')
  // ?postureHoldLook=gold: 体幹の戻りが止まっている間の見せ方を前の形 (金の縁の光・稽古は帯と体を真鍮の輪で照らす) へ戻す (10-28・src/tut_focus.ts applyPostureHoldLook)。
  applyPostureHoldLook(new URLSearchParams(location.search).get('postureHoldLook'))
  // ?postureHoldTip=glow|crystal|flame|none: 霜の帯の先端の印の比較版 (10-31・src/player_combo3_power.ts PostureHoldTip)。省略 = 印なし (配布版・clasp で旧の留め金)。
  setPostureHoldTip(new URLSearchParams(location.search).get('postureHoldTip'))
  // ?roosterFx=now: 鶏の前の仮の FX (10-31 に羽根の演出を既定へ・src/rooster_fx.ts)。
  setRoosterFx(new URLSearchParams(location.search).get('roosterFx'))
  // ?roosterMove=slide: 鶏の待ちの間の寄り・下がりを前の版 (立ち絵のまま滑る) へ戻す。省略 = 配布版 (跳ねて時々主人公を跳び越える・11-04 作者 ship=yes・src/rooster_hop_move.ts)。
  setRoosterHopMove(new URLSearchParams(location.search).get('roosterMove'))
  // ?roosterFeather=white|code: 鶏の羽根の前の版 (white = 白い描いた羽根・code = コードの葉形)。既定 = 本体の羽の色の絵 (10-31 作者の答え・src/rooster_fx.ts)。
  setRoosterFeather(new URLSearchParams(location.search).get('roosterFeather'))
  // ?lampMote=old: 常夜燈の光の粒を揃える前 (場所ごとに色と大きさが違う) へ戻す (10-31・src/lamp_mote.ts)。
  setLampMoteLook(new URLSearchParams(location.search).get('lampMote'))
  // ?lampLight=old: 常夜燈の明かりを前の版 (丸1つ) へ戻す。既定 = v1 (芯から減るにじみ・炎の揺らぎ・照り返し・粒・11-02 作者の答えで配布版・src/lamp_light.ts)。
  setLampLightLook(new URLSearchParams(location.search).get('lampLight'))
  // ?loading=moon|none: 読み込み待ちの表示を月・黒だけにする (src/loading_indicator.ts)。省略 = 常夜燈 (11-02 作者の答えで配布版)。
  //   &loadingHold=<秒>: 手元でも待ちを作る (会話場面の頭と戦いへ抜ける時・上限 6 秒)。
  setLoadingLook(new URLSearchParams(location.search).get('loading'))
  setFakeLoadMs(Number(new URLSearchParams(location.search).get('loadingHold') ?? 0) * 1000)
  ;(window as any).__combo3rd = () => combo3rdPercent()
  ;(window as any).__combo3rdTrial = () => combo3rdTrialInfo()
  // ?reachArt=off|executioner|awoken|both: 介錯・覚醒王の当たりの前端。既定 = both (絵＋15・2026-10-09 ユーザー採用・src/exec_awoken_reach.ts が読み込み時に当てる)。
  //   off = 旧 (比較用)。検収パック archived/2026-11-03-exec-rooms/kensyu-exec-awoken-reach.html が window.__reachArt() で効いているかを確かめる。配布版はクエリを読まず既定のまま。
  setExecAwokenReachVariant(parseExecAwokenReachVariant(new URLSearchParams(location.search).get('reachArt')) ?? 'both')
  ;(window as any).__reachArt = () => getExecAwokenReachVariant()
  // 覚醒王の AI の遊び点検 (10-09)。2026-10-08 ユーザー採用 (検収 F-1・F-1b・F-2) = 配布版の既定 (src/fresh_eyes_fix_trials.ts・balance.ts)。
  //   ?awokenWall=<px> 覚醒王の壁の内寄せ (0..106・既定 100・0 = 旧＝壁まで行く) / ?houndWall=<px> 戴冠獣 (0..136・既定 120・0 = 旧) /
  //   ?defeatHint=now 負け画面の一言を旧の小さい版に (既定 = big = 21px・濃い) / ?deathFront=1 負けの一拍の間、伏した主人公を FX より手前に描き縁を光らせる (F-3・不採用・比較用に残す)。
  //   検収パック kensyu-fresh-eyes-fix.html が __freshEyesFix() で確かめる。
  {
    const q = new URLSearchParams(location.search)
    if (q.has('awokenWall')) setAwokenWallInsetTrial(Number(q.get('awokenWall'))) // 既定 = 100 (10-08 ユーザー採用 F-1)・指定なしは触らない・0 = 旧
    if (q.has('houndWall')) setHoundWallInsetTrial(Number(q.get('houndWall')))   // 既定 = 120 (10-08 ユーザー採用 F-1b)・指定なしは触らない・0 = 旧
    if (q.has('brideWall')) setBrideWallInsetTrial(Number(q.get('brideWall'))) // 花嫁 (0..50)。既定 = 37 (10-08 ユーザー採用)・指定なしは触らない・0 = 旧
    if (q.has('knightWall')) setKnightWallInsetTrial(Number(q.get('knightWall'))) // 騎士 (0..45)。既定 = 25 (10-08 ユーザー採用)・指定なしは触らない・0 = 旧 (壁まで行く)
    setDefeatHintMode(parseDefeatHintMode(q.get('defeatHint')) ?? 'big')
    setDeathFrontMode(parseDeathFrontMode(q.get('deathFront')) ?? 'off')
  }
  //   __freshEyesFix() = いま効いている版を返す。__freshEyesFix({ defeatHint: 'now', deathFront: 'on', awokenWall: 0 }) = 読み込み直さずに替える
  //   (パックの「その場で見比べ」と撮影用。渡した項目だけ替える)。
  ;(window as any).__freshEyesFix = (patch?: { awokenWall?: number; houndWall?: number; brideWall?: number; knightWall?: number; defeatHint?: string; deathFront?: string }) => {
    if (patch?.awokenWall !== undefined) setAwokenWallInsetTrial(Number(patch.awokenWall))
    if (patch?.houndWall !== undefined) setHoundWallInsetTrial(Number(patch.houndWall))
    if (patch?.brideWall !== undefined) setBrideWallInsetTrial(Number(patch.brideWall))
    if (patch?.knightWall !== undefined) setKnightWallInsetTrial(Number(patch.knightWall))
    if (patch?.defeatHint !== undefined) setDefeatHintMode(parseDefeatHintMode(patch.defeatHint) ?? 'big')
    if (patch?.deathFront !== undefined) setDeathFrontMode(parseDeathFrontMode(String(patch.deathFront)) ?? 'off')
    return { awokenWall: BOSS_BODY_WALL_INSET_PX['crowned-king-awoken'] ?? 0, houndWall: BOSS_BODY_WALL_INSET_PX['dream-hound'] ?? 0,
      brideWall: BOSS_BODY_WALL_INSET_PX['bride'] ?? 0, knightWall: BOSS_BODY_WALL_INSET_PX['vigil-knight'] ?? 0,
      defeatHint: defeatHintMode(), deathFront: deathFrontMode() }
  }
  // ?parryOne: パリィを1種類にする (10-09 ユーザー裁定・10-10 既定にした・src/parry_one.ts)。既定 (指定なし・on・a) = 押してから 120ms 以内の弾きを全部「旧のジャストパリィ」の扱いに・
  //   それより早い押しは長押しならガード・離していたら当たる。=off (または 0) で旧 (ジャスト 80ms と普通のパリィ)。b = ボスへ 20・自分へ 8。
  //   検収パック kensyu-parry-one.html が __parryOne() で効いているかを確かめる。
  setParryOneMode(parseParryOneMode(new URLSearchParams(location.search).get('parryOne')) ?? 'a')
  ;(window as any).__parryOne = (m?: string) => { if (m !== undefined) setParryOneMode(parseParryOneMode(m) ?? 'a'); return parryOneMode() }
  // ?defeatTips=new: 負け画面の一言をロード画面の Tips 式 (小技・小ネタから毎回1つ・会ったボスの分だけ) にする比較版 (src/defeat_tips.ts・10-09)。
  //   指定なし = 今のまま (死因連動の1行)。__defeatTips() = いまの版と出せる文の数。__defeatTips('new'|'now') = 読み込み直さずに替える。
  //   検収パック kensyu-defeat-tips.html が使う。
  setDefeatTipsMode(parseDefeatTipsMode(new URLSearchParams(location.search).get('defeatTips')) ?? 'now')
  //   __defeatTips('new', 'bride') = 本編を花嫁まで進めた人と同じ「会ったボス・読んだ場面」を、Tips の選び方にだけ仮に足す
  //   (一戦だけモード ?fight= は物語を見ていないので小ネタが出ない。パックで小ネタも見るための仮の進み具合。
  //    campaign 自体は触らない = 保存にも進行にも影響しない。再演で戦いを作り直しても残る。'' で外す)。
  ;(window as any).__defeatTips = (m?: string, progressUpTo?: string) => {
    if (m !== undefined) setDefeatTipsMode(parseDefeatTipsMode(m) ?? 'now')
    const upTo = progressUpTo ? BOSS_DEFINITIONS.findIndex((d) => d.id === progressUpTo) : -1
    if (upTo >= 0) {
      const before = BOSS_DEFINITIONS.slice(0, upTo).map((d) => d.id)
      setDefeatTipsDevProgress({ defeatedBossIds: before,
        seenScenes: [...before.flatMap((id) => [`prebattle:${id}`, `interlude:${id}`]), `prebattle:${progressUpTo}`] })
    } else if (progressUpTo !== undefined) setDefeatTipsDevProgress(null)
    const pool = eligibleDefeatTipsFor(state.campaign, state.boss.id)
    return { mode: defeatTipsMode(), eligible: pool.length, skill: pool.filter((t) => t.kind === 'skill').length,
      lore: pool.filter((t) => t.kind === 'lore').length, total: activeDefeatTips().length }
  }
  // ?attackTempo=A|B|C: 連撃の速さと1振りの配分 (player_attack_timing.ts・既定 B)。
  setAttackTempo(new URLSearchParams(location.search).get('attackTempo'))
  setWallHuntGame(new URLSearchParams(location.search).get('wallHunt') !== 'old')
  // ?wallHuntAim=fixed|aim|half: 新しい版の帰りの狙い (既定 fixed = 今の新しい版のまま)。今の版では効かない。
  setWallHuntAim(new URLSearchParams(location.search).get('wallHuntAim'))
  // ?wallHuntSpirits=on|off: 新しい版の帰りの蹴り出しで、蹴った壁に大暴れの怨念を3つ残すか (既定 off＝2026-10-09 ユーザー「怨念いらないな」で配布版から外した。on で戻る)。今の版では効かない。
  setWallHuntSpirits(new URLSearchParams(location.search).get('wallHuntSpirits'))
  // ?wallSpiritTiming=old: その怨念の届く時刻と付いて行き方を 10-07 の直し前 (750/1200/1650ms・回避の動きにも付いて行く) へ戻す比較。
  setWallHuntSpiritTiming(new URLSearchParams(location.search).get('wallSpiritTiming'))
  // ?wallDashFix=off|pounce|late|dmg: 壁跳ね・往の比較版 (src/awoken_wall_dash_fix.ts)。既定 = pounce (2026-10-10 ユーザー採用「案1だけ」)。旧は ?wallDashFix=off。配布版は URL を読まない。
  //   pounce = 踏み切りで最大 100px 跳びかかって当てる (推奨) / late = 踏み切りで届かない時は 245ms より前に当てない / dmg = 往の傷を 18・36 → 12・24。
  //   window.__wallDashFix() でいま効いている案を返す。研究 = docs/research/2026-10-09-awoken-wall-dash-fix-options.md。
  setWallDashFix(new URLSearchParams(location.search).get('wallDashFix'))
  // ?huntLeap=now: 前の版 (1022 で 1021 を採用・配布版へ)。1021: 壁跳ねの跳びを「跳んだ瞬間が一番速く、着くまでに減速」へ引き直し、着地の後の停止の絵に沈みを足す比較版 (src/awoken_wall_hunt_game.ts・検収パック 1022)。
  setWallHuntLeap(new URLSearchParams(location.search).get('huntLeap'))
  // ?mortarRecoil=now: 前の版 (1022 で採用・撃つと沈む形に直して配布版へ)。1021: 介錯の山なり榴弾を、砲を掲げたまま体ごと後ろ・上へはね上がる反動にした比較版 (src/boss_pose_timeline.ts・検収パック 1022)。
  setExecutionerMortarRecoil(new URLSearchParams(location.search).get('mortarRecoil'))
  // ?execHolds=now: 前の版 (1022 で採用)。1021: 介錯の振り下ろし・地割りの硬直で、刃先を床へ預けた棒立ちの絵を出さず、当たった絵のまま体を起こして待機へ戻す比較版 (src/boss_pose_timeline.ts・検収パック 1022)。
  setExecutionerHolds(new URLSearchParams(location.search).get('execHolds'))
  // ?execTwoKeys=1: 介錯の振り下ろしに、着弾後の沈みの絵を1枚足した比較版 (src/boss_pose_timeline.ts・2026-10-22。引き絞りの絵は作者の答えで外した)。配布版は URL を読まない。
  setExecutionerTwoKeys(new URLSearchParams(location.search).get('execTwoKeys'))
  // ?knockSkid=now: 前の版 (1022 で採用)。1021: 大きく押し飛ばされた時に、足の滑りの擦り跡・土煙・滑る音 (仮) を付ける比較版 (src/exec_knock_skid.ts・検収パック 1022)。
  setKnockSkid(new URLSearchParams(location.search).get('knockSkid'))
  // ?stepWeight=now: 前の版 (1022 で採用)。1021: 介錯の一歩に沈み・着地の潰れ・蹴り出しと着地の土煙を付け、後ろ跳びを蹴った瞬間が一番速い進み方にした比較版 (src/exec_step_weight.ts・検収パック 1022)。
  setStepWeight(new URLSearchParams(location.search).get('stepWeight'))
  // ?auraBodyPose=old (DEV・2026-10-21・src/render.ts bossBodyDrawPose): 紫/赤のオーラの形を前の置き方で焼く (介錯の一歩で縁が体から離れていた版)。
  setAuraBodyPose(new URLSearchParams(location.search).get('auraBodyPose'))
  ;(window as any).__wallDashFix = () => wallDashFix()
  // ?rampageSpiritHold=follow|wall: 大暴れの怨念を、飛び出すまで生まれた点に留めるか (既定 wall = 本番と同じ・09-25 裁定) 旧の動きで主人公の周りへ漂わせるか (follow)。
  setRampageSpiritHold(new URLSearchParams(location.search).get('rampageSpiritHold'))
  // ?soloDiff=senshuraku|hatsuen (10-09 夜・?fight= と一緒に使う): 一戦だけモードの難易度。既定 (指定なし) = 今どおり初演。配布版は読まず常に初演。
  //   ?hatsuenTime=1 (同): 初演の時だけ、主人公のパリィの受付 +40ms・回避の無敵 100→150ms (ボス側は触らない・千秋楽では効かない・src/difficulty.ts)。
  //   検収パック kensyu-senshuraku.html が使う。
  setSoloDifficulty(parseSoloDifficulty(new URLSearchParams(location.search).get('soloDiff')) ?? SOLO_DIFFICULTY)
  setHatsuenTimeRelief(new URLSearchParams(location.search).get('hatsuenTime') === '1')
  // ヒットストップ中は押しのバッファの寿命を進めない = ストップ中に押した次のパリィ・攻撃・回避が、
  //   ストップ明けの最初の更新で普段どおり使われる。既定 (指定なし・hold) = 保つ (2026-10-12 ユーザー採用・配布版・試遊パック 10-10 の答え E-1)。
  //   旧は DEV ?hitstopBuffer=off (ストップ前半の押しがストップ明けまで持たず消える)。
  //   hold (押しっぱなし)・移動の軸・メニューのエッジは変えない (docs/research/2026-10-09-hitstop-input-buffer-status.md)。
  bufferAgeHeldInHitstop = new URLSearchParams(location.search).get('hitstopBuffer') !== 'off'
  //   __difficultyInfo() = いま効いている難易度と、主人公の時間 (パリィの受付・回避の無敵 ms) を返す (検収パックが「効いているか」を表示する)。
  ;(window as any).__difficultyInfo = () => ({
    difficulty: getDifficulty(), hatsuenTime: hatsuenTimeReliefActive(),
    parryActiveMs: playerParryActiveMs(), dodgeIFrameMs: playerStepIFrameMs(),
  })
  const rawFootLift = new URLSearchParams(window.location.search).get('footLift')
  const requestedFootLift = rawFootLift === null ? NaN : Number(rawFootLift)
  if (Number.isInteger(requestedFootLift) && requestedFootLift >= 0 && requestedFootLift <= 12) {
    // 2026-11-03: ?fight=dream-hound と組むと四つ足の王にも効く (駅7 #4 の見比べ)。指定なしは介錯。
    setBossFootLiftOverride(soloBossId === 'dream-hound' ? 'dream-hound' : 'the-executioner', requestedFootLift)
  }
  // ?bossScale=<1.0..2.5>: 介錯の等身 (BOSS_HEIGHT_RATIO・既定 2.0) を実プレイで見比べる用のつまみ (2026-09-02 見た目の棚卸し §C3)。
  const rawBossScale = new URLSearchParams(window.location.search).get('bossScale')
  const requestedBossScale = rawBossScale === null ? NaN : Number(rawBossScale)
  if (Number.isFinite(requestedBossScale) && requestedBossScale >= 1.0 && requestedBossScale <= 2.5) {
    setBossHeightRatioOverride('the-executioner', requestedBossScale)
  }
  // 2026-10-19: ?bladeArt=old で剣舞を旧 E-5 の絵・右向き・1.25 倍・城の背景へ戻す (新旧の見比べ用・src/blade_dancer_art.ts)。
  if (new URLSearchParams(window.location.search).get('bladeArt') === 'old') useBladeDancerOldArt()
  // 2026-10-20: ?awokenRoom=old で覚醒王の部屋を旧 (城の既定の背景＋仮の石の板) へ戻す (新旧の見比べ用・render.ts useAwokenOldRoom)。
  if (new URLSearchParams(window.location.search).get('awokenRoom') === 'old') useAwokenOldRoom()
  // 2026-11-03: 鶏の部屋は鐘楼の頂上 (床を手前へ伸ばした版) が配布版。 ?roosterRoom=castle で城の既定、 v1 で床を伸ばす前の鐘楼へ戻す (render.ts useRoosterOldRoom)。
  const roosterRoom = new URLSearchParams(window.location.search).get('roosterRoom')
  if (roosterRoom === 'castle' || roosterRoom === 'v1') useRoosterOldRoom(roosterRoom)
  // 2026-10-27: ?awokenFloor=old で覚醒王の部屋を旧の 0.6 倍で流す (既定は柱と同じ 1.0 倍・柱も揺らさない・render.ts useAwokenRoomSlide)。
  if (new URLSearchParams(window.location.search).get('awokenFloor') === 'old') useAwokenRoomSlide()
  // 2026-10-19: ?bladeMoves=1 で剣舞の技ごとの絵 (B を見本に描き直した構え・振り・弾かれ・崩れ・撃破) を出す比較版 (src/blade_dancer_art.ts)。
  if (new URLSearchParams(window.location.search).get('bladeMoves') === '1') useBladeDancerMoveArt()
  // 剣舞の円舞連斬と終舞の動き。10-21 から 5回目 (v6) が配布版の既定。前の版は ?bladeMotion=v2〜v5、v2 より前の配布版は ?bladeMotion=old で比べる。
  //   v2 = 動きから1から作り直した12コマ／v3 = メリハリ (振る所を速く・見得で止める・弾かれてもひるまない)
  //   v4 = 回る絵 5 を外す・終舞の構え・替わり目を溶かす・斬りの跡／v5 = 終舞の構えを舞踏会の誘いに
  //   v6 = 3連・5連の8発を1発ずつ描き直す・両刃に見える絵を外す・締めの礼・刃の花びらの火花 (src/blade_dancer_art.ts)
  //   旧の絵 (?bladeArt=old) と技ごとの絵 (?bladeMoves=1) の比較版には v6 を重ねない。
  const bladeMotion = new URLSearchParams(window.location.search).get('bladeMotion')
  if (bladeMotion === 'v2') useBladeDancerMotionV2()
  else if (bladeMotion === 'v3') useBladeDancerMotionV3()
  else if (bladeMotion === 'v4') useBladeDancerMotionV4()
  else if (bladeMotion === 'v5') useBladeDancerMotionV5()
  else if (bladeMotion !== 'old'
    && new URLSearchParams(window.location.search).get('bladeArt') !== 'old'
    && new URLSearchParams(window.location.search).get('bladeMoves') !== '1') {
    // 斬りの跡: 10-21 から剣先の軌跡の帯 (残像) が既定。?bladeTrail=glass で硝子の弧、?bladeTrail=petals で 10-20 の火花と花びら。
    const t = new URLSearchParams(window.location.search).get('bladeTrail')
    useBladeDancerMotionV6(t === 'glass' || t === 'petals' ? t : 'afterimage')
    // 円舞の3連は 10-23 から v7 (10-22 作者「周りはC,決めはB」・回りは円舞・決めは頭上の X) が既定。当たりと時間は v6 のまま。?bladeWaltz=v6 で前の絵。
    //   2・3連撃目の跡は 10-23 から切っ先の軌道の長さ (作者「長さを切っ先の軌道通り出して」)。?bladeTrailLen=now で前の短い跡。
    if (new URLSearchParams(window.location.search).get('bladeWaltz') !== 'v6') useBladeDancerWaltzV7(t === 'glass' || t === 'petals' ? t : 'afterimage', parseBladeTrailLen(new URLSearchParams(window.location.search).get('bladeTrailLen')))
    // 弾いた時の斬りの跡 (10-23 作者「剣のエフェクトが途中で切れてるように見えたり」→ 答え T-2 A): 既定は伸びきった帯。?bladeTrailStop=now で前の版、=knight で騎士の細い線。
    useBladeTrailStop(parseBladeTrailStop(new URLSearchParams(window.location.search).get('bladeTrailStop')))
    // 攻撃の絵の体の大きさ (10-23 作者「攻撃中だけ体が大きい」): 配布版は立ち姿にそろえた fit。?bladeBodySize=now で前の大きさ、=small でもう一回り小さく。
    useBladeBodySize(parseBladeBodySize(new URLSearchParams(window.location.search).get('bladeBodySize')))
    // 絵ごとの色の差 (10-23 作者「ボスの色が安定してない」): 配布版は補正なし。?bladeColor=idle で立ち姿の色へ、=mid で全部の絵の真ん中の色へそろえる。
    useBladeColor(parseBladeColor(new URLSearchParams(window.location.search).get('bladeColor')))
    // 色を立ち姿にそろえて描き直した攻撃の絵 (10-23 作者 C-1「絵を直したい」): 10-23 の答えで描き直しが配布版の既定。前の絵は ?bladePaint=now (src/blade_art_repaint.ts)。
    useBladeArt(parseBladeArt(new URLSearchParams(window.location.search).get('bladePaint')))
    // 裾払いの予備動作: 10-21 作者の答えで a 沈む礼が既定。?bladeHemWindup=b|c で比べ、=now で前の予告 (src/blade_hem_windup.ts)。
    useBladeHemWindup(parseBladeHemWindup(new URLSearchParams(window.location.search).get('bladeHemWindup')))
    // 円舞と終舞の拍を 10-17 の答えるページ (Y2tz) の見本へ合わせた版: 10-24 作者の答え Y-1 で配布版の既定。?bladeTempo=old で前のテンポ (src/blade_dancer_art.ts useBladeDancerTempoY2tz)。
    if (new URLSearchParams(window.location.search).get('bladeTempo') !== 'old') useBladeDancerTempoY2tz()
    // 旋回突きをアルレッキーノの4連にした版 (10-25・開発版だけ・?bladePirouette=b4・src/blade_dancer_pirouette.ts)。
    if (import.meta.env.DEV && parseBladePirouette(new URLSearchParams(window.location.search).get('bladePirouette'))) useBladeDancerPirouetteB4(t === 'glass' || t === 'petals' ? t : 'afterimage')
    // 新しい技「遅れの一撃」(10-25・開発版だけ・?bladeGamma=1・src/blade_dancer_gamma.ts)。
    if (import.meta.env.DEV && parseBladeGamma(new URLSearchParams(window.location.search).get('bladeGamma'))) useBladeDancerGamma(t === 'glass' || t === 'petals' ? t : 'afterimage')
    // 新しい技「引き寄せ」(10-25・開発版だけ・?bladePull=1・src/blade_dancer_pull.ts)。
    if (import.meta.env.DEV && parseBladePull(new URLSearchParams(window.location.search).get('bladePull'))) useBladeDancerPull(t === 'glass' || t === 'petals' ? t : 'afterimage')
    // 新しい技「跳んで叩く」(10-25・開発版だけ・?bladeDelta=1・src/blade_dancer_delta.ts)。
    if (import.meta.env.DEV && parseBladeDelta(new URLSearchParams(window.location.search).get('bladeDelta'))) useBladeDancerDelta(t === 'glass' || t === 'petals' ? t : 'afterimage')
    // 技「回って終わる連」(10-25 開発版で作り、10-28 夜 作者の答え M-4「入れてよい」で配布版へ・src/blade_dancer_spin.ts)。外すのは ?bladeSpin=0。
    //   配布版 = 描き直した2版目の回る絵・1周に当たり2回 (M-3)・戻りは振り抜き → 両腕を広げる締め → 立ち姿。
    //   比べる旗は開発版だけ: ?bladeSpinTurn=0 で回る絵なし・=1 で1版目、?bladeSpinHits=old で回る間の当たりが無い前の3発。下の bladeArle より先に。
    if (import.meta.env.DEV) {
      setBladeSpinTurn(parseBladeSpinTurn(new URLSearchParams(window.location.search).get('bladeSpinTurn')))
      setBladeSpinOldHits(parseBladeSpinHits(new URLSearchParams(window.location.search).get('bladeSpinHits')))
      // 1周の2発の間を詰める前 (0.3 秒) の形 (10-28 深夜 M-5 の比較・?bladeSpinPair=old)。
      setBladeSpinWidePair(parseBladeSpinPair(new URLSearchParams(window.location.search).get('bladeSpinPair')))
    }
    if (parseBladeSpin(new URLSearchParams(window.location.search).get('bladeSpin'))) useBladeDancerSpin(t === 'glass' || t === 'petals' ? t : 'afterimage')
    // 新しい技「暗器投げ」(10-25・開発版だけ・?bladeThrow=1・src/blade_dancer_throw.ts)。
    if (import.meta.env.DEV && parseBladeThrow(new URLSearchParams(window.location.search).get('bladeThrow'))) useBladeDancerThrow()
    // アルレッキーノを落とし込んだ一戦 (10-25 開発版で作り、10-29 配布版の既定へ・?bladeArle=0 で前の4技の一戦・上の技を全部入れ、技と技を連でつなぐ・src/blade_dancer_arle.ts)。
    //   ?bladePullFx=a|b|c = 旋回突きの引き戻しの跡の案 (10-27・a 二閃・b 十字・c 刃の影・未指定は作者が選んだ c・old = 10-27 の跡)。
    //   10-28 引き寄せ単体の ?bladePull=1 と名前が重なっていたので分けた。
    if (parseBladeArle(new URLSearchParams(window.location.search).get('bladeArle'))) {
      useBladeDancerArle(t === 'glass' || t === 'petals' ? t : 'afterimage', parseBladePullFx(new URLSearchParams(window.location.search).get('bladePullFx')))
      // 仮の FX を描いた絵の質感へ替えた (10-31 作者の答えで既定・?bladeFx=now で前の見た目・src/blade_dancer_fx_v2.ts)。
      //   γ の爆ぜと δ の突き立ての、コードで描いた花びらと火花を外し、ひび・炎・焦げ跡・土ぼこりの絵に替える。
      const bladeFx = parseBladeFx(new URLSearchParams(window.location.search).get('bladeFx'))
      setBladeFx(bladeFx)
      if (bladeFx !== 'now') for (const k of BLADE_FX_V2_DROPPED_SMEARS) delete SMEAR_ARTS[k]
      // 残りの仮の FX（引き寄せの帯・暗器の小刀）を描いた絵へ (src/blade_dancer_fx_rest.ts)。11-01 作者の答えで帯は既定 (太さ 16・?bladeSashW で変える)。
      //   小刀も白い丸を消した描いた絵が既定 (11-01 見せ直しで A)。?bladeFxRest=sash で小刀だけ前の見た目、?bladeFxRest=now で両方とも前の見た目。
      const q = new URLSearchParams(window.location.search)
      setBladeFxRest(parseBladeFxRest(q.get('bladeFxRest')), parseBladeSashWidth(q.get('bladeSashW')))
      // 借りている絵を専用の絵へ (src/blade_own_art.ts)。δ の低い払いは 11-01 作者の答え (描き直し v2 を pass) で配布版の既定。
      //   前の借りた絵 (引き寄せの c_5) は開発版だけ ?bladeOwnArt=old。
      if (!import.meta.env.DEV || parseBladeOwnArt(q.get('bladeOwnArt'))) useBladeOwnArt(t === 'glass' || t === 'petals' ? t : 'afterimage')
      // γ の戻りに専用の残心を挟む (11-03 作者の答え「残心を挟む」で配布版の既定・docs/research/2026-11-02-blade-next.md)。前の版は開発版の ?bladeGammaRest=old。
      if (!import.meta.env.DEV || q.get('bladeGammaRest') !== 'old') useBladeGammaRest()
      // 大振りの2発目の前後を正面の斬り上げに替え、速い連の当たりと合図の構えを専用の絵にする (11-04 作者の答え grand=v3b で配布版の既定・docs/research/2026-11-04-blade-grand-v3.md)。
      //   開発版だけ ?bladeGrandQuick=old で前の借りた絵・=v1・=v3 は比較版。
      const grandQuick = import.meta.env.DEV ? parseBladeGrandQuick(q.get('bladeGrandQuick')) : 'v3b'
      if (grandQuick !== 'off') useBladeGrandQuickType(t === 'glass' || t === 'petals' ? t : 'afterimage', grandQuick)
      // 速い連の1式を専用の11枚に (開発版だけ ?bladeQuick=v1104・=v1104b は倍率を1枚ごとにそろえた版・=spin1/spin4 は間で体を1周させる版・docs/research/2026-11-03-blade-quick-spin4.md)。
      const quickArt = import.meta.env.DEV ? parseBladeQuickArt(q.get('bladeQuick')) : 'off'
      if (quickArt !== 'off') useBladeQuickArt(t === 'glass' || t === 'petals' ? t : 'afterimage', quickArt)
    }
  }
  // 2026-10-21: 作者の答えで裾払いを50px広げた。?bladeHemWidth=130 で前の幅と比べる (既定180)。
  setBladeHemWidth(new URLSearchParams(window.location.search).get('bladeHemWidth'))
  // 2026-10-19: ?parriedPose=overlay|cut で、弾いた瞬間の弾かれの絵の見せ方を比べる (配布版の既定＝重ねず押し戻す A／overlay＝前の半透明の重ね／cut＝B ぱっと替えて止める・src/sprites.ts)。
  setParriedPoseTrial(parseParriedPoseTrial(new URLSearchParams(window.location.search).get('parriedPose')))
  // 🔵 2026-09-03 第3便: 榴弾の散り方 A/B を実プレイで見比べる用。
  const rawMortar = new URLSearchParams(window.location.search).get('mortar')
  if (rawMortar === 'A' || rawMortar === 'B') setExecutionerMortarSpread(rawMortar)
  // 🔵 2026-09-03 第4便: 砲の間合いを実プレイで見比べる用 (既定400)。
  const rawCannonRange = new URLSearchParams(window.location.search).get('cannonRange')
  const requestedCannonRange = rawCannonRange === null ? NaN : Number(rawCannonRange)
  if (Number.isFinite(requestedCannonRange)) setExecutionerCannonRange(requestedCannonRange)
  // 🔵 2026-09-03 第4便: 腕砲の弾の見た目 (orb=紫の光の玉/既定・rock=旧岩塊) を実プレイで見比べる用。
  const rawShot = new URLSearchParams(window.location.search).get('shot')
  if (rawShot === 'orb' || rawShot === 'rock') setCannonShotLook(rawShot)
  // 🔵 2026-09-03 第5便: 地割りの床の演出 3案 (a/b/c・old=旧) を実プレイで見比べる用。既定 a。
  const rawQuake = new URLSearchParams(window.location.search).get('quake')
  if (rawQuake === 'a' || rawQuake === 'b' || rawQuake === 'c' || rawQuake === 'old') setQuakeLook(rawQuake)
  // 発勁の光波 a〜f・old の実プレイ比較。2026-09-10: e/f 追加、既定 e（Astra 推奨・未検収）。
  const rawFajin = new URLSearchParams(window.location.search).get('fajin')
  if (rawFajin === 'a' || rawFajin === 'b' || rawFajin === 'c' || rawFajin === 'd' || rawFajin === 'e' || rawFajin === 'f' || rawFajin === 'g' || rawFajin === 'h' || rawFajin === 'i' || rawFajin === 'j' || rawFajin === 'old') setFajinLook(rawFajin)
  // 🔵 2026-09-10: d だけの色 (violet=作品の紫/既定・gold=参考画像の金白) を実プレイで見比べる用。
  const rawFajinTint = new URLSearchParams(window.location.search).get('fajinTint')
  if (rawFajinTint === 'gold' || rawFajinTint === 'violet') setFajinTint(rawFajinTint)
}
// 配布版の剣舞＝v6 (斬りの跡は切っ先の軌跡) と裾払いの予備動作 a 沈む礼。DEV は上の箱で URL から選ぶ。
//   10-21 まで箱の中でしか呼んでおらず、本番の束では v6 の動きが削られて v2 より前の動きが出ていた。
if (!import.meta.env.DEV) {
  useBladeDancerMotionV6('afterimage')
  useBladeDancerWaltzV7('afterimage')
  useBladeTrailStop('full')
  useBladeBodySize('fit')
  useBladeHemWindup('a')
  useBladeDancerTempoY2tz()   // 円舞と終舞の拍 (10-24 作者 Y-1 で配布版へ)
}
if (soloBossId) {
  const soloState = createSoloState(soloBossId)
  if (soloState) state = soloState
  else console.warn(`[fight] そのボスは居ません: ${soloBossId}`)
}
// Public review of provisional ADV art/text: isolated scratch state, never a campaign run.
function restartAdvPreview(): GameState {
  const id = advPreviewId!
  const scratch = createSoloState(id)!
  const scene = getPreBattleScene(id, scratch.campaign)!
  preloadAdvPictures(scene)
  preloadAdvPictures(getInterludeScene(id))
  return { ...scratch, solo: false, phase: 'preBattle', adv: startScene(scene), phaseElapsedSec: 0 }
}
if (advPreviewId) {
  if (advPreview) state = restartAdvPreview()
  else { state = { ...createInitialState(), phase: 'title' }; console.warn(`[advPreview] Unknown scene: ${advPreviewId}`) }
}
if (import.meta.env.DEV && new URLSearchParams(window.location.search).get('endingPreview') === 'stay') {
  state = { ...createInitialState(), phase: 'ending', endingChoice: 'stay', adv: startScene(getEndingScene('stay')), phaseElapsedSec: 0 }
}
// ?room=<n> / ?soloString=<id> (dev 限定): 実プレイで「幕n・この連だけ」を1本のリンクで開く
//   (2026-09-09 発勁の突き＝地割りの直後だけ出る連を、コンソール無しでユーザーが確かめる用)。
//   __setBossRoom / __soloString と同じ中身。例: ?fight=the-executioner&room=1&soloString=exec-maul-quake-fajin
if (import.meta.env.DEV) {
  const rawRoom = new URLSearchParams(window.location.search).get('room')
  // ?bossProxy=blade-dancer = 駅1 の仮の絵で出す (src/boss_proxy.ts)。
  const proxyIds = new URLSearchParams(window.location.search).get('bossProxy')
  for (const id of proxyIds?.split(',') ?? []) {
    if (id.trim()) setBossProxyEnabled(id.trim(), true)
  }
  const requestedRoom = rawRoom === null ? NaN : Number(rawRoom)
  if (Number.isInteger(requestedRoom) && requestedRoom >= 0) {
    state = { ...state, phase: 'playing', boss: { ...state.boss, executesTaken: requestedRoom } }
  }
  const rawSoloString = new URLSearchParams(window.location.search).get('soloString')
  if (rawSoloString) setDebugSoloString(rawSoloString)
  const rawKnightStart = new URLSearchParams(window.location.search).get('knightStart')
  const knightStart = rawKnightStart === null ? NaN : Number(rawKnightStart)
  if (state.boss.id === 'vigil-knight' && Number.isFinite(knightStart)) {
    const bounds = arenaBoundsFor('vigil-knight')
    state = { ...state, boss: { ...state.boss,
      x: Math.max(bounds.leftWall, Math.min(bounds.rightWall, knightStart)) } }
  }
  // Open the candidate in its actual form without requiring a console command.
  if (cannonFajinReview && state.boss.exec) {
    state = { ...state, boss: { ...state.boss, executesTaken: Math.max(1, state.boss.executesTaken),
      exec: { ...state.boss.exec, held: 'cannon', morph: 'no', morphElapsedMs: 0 } } }
  }
}

// 鶏の一戦 (10-29 から配布版・src/rooster_fight.ts): 技5本・2幕。開発版の ?roosterParryMul= だけ弾いた時の体幹の溜まりを替える。
if (import.meta.env.DEV) setRoosterParryPostureMul(new URLSearchParams(window.location.search).get('roosterParryMul'))
useRoosterFight()
preloadBossSprites(state.boss.id)
/** 初めて描く絵は、その1コマが重かった (11-04 剣舞・騎士・花嫁の致命、11-03 全ボスの普段の技)。いまのボスになった時に手すきで測っておく (次のボスの先読みではしない)。
 *  一覧は先に測る絵。一覧の無いボスも、読んだ絵は全部測る = src/sprites.ts warmBossSpriteMeta。 */
const BOSS_WARM_KEYS: Readonly<Record<string, readonly string[]>> = {
  'blade-dancer': BLADE_EXEC_WARM_KEYS,
  // 騎士は致命の3枚と、致命の入りの振り向き・駆け寄り・踏ん張りで初めて出る4枚 (src/exec_unique.ts knightChargeRunImageAt)。
  // 花嫁は致命の中で初めて出る4枚 (src/exec_unique.ts BRIDE_EXEC_ART)。
  bride: ['exec_found_1009', 'exec_glide_1009', 'exec_coil_1009', 'exec_okaeri_1009'],
  'vigil-knight': ['turn', ...Object.values(KNIGHT_EXEC_ART), 'charge_run1', 'charge_run2', 'scrape_stop'],
}
function warmCurrentBossArt(bossId: string): void {
  warmBossSpriteMeta(bossId, BOSS_WARM_KEYS[bossId] ?? [])
}
warmCurrentBossArt(state.boss.id)
// 主人公の通常攻撃の描いたコマ (player_attack_frames.ts) は開発中の ?playerAttackArt=frames だけ = 描く時に読む。配布版では読まない。
// 🔴 2026-07-28: 旧 LUNAIRE スプライト (lunaire-v2) の先読みを撤去した。
//   Spine リグに全アニメ (idle/walk/walk_back/attack各種/parry/guard各種/dodge/counter/
//   hurt/stunned/exhausted/execute各種/defeat の20個) が author 済で、
//   `/sprites/lunaire-v2/**` を通信ごと遮断して実測しても描画は一切変わらなかった
//   = 到達しない保険のために毎起動 17件・12.7MB を落としていた。
//   素材は public/sprites/archived/lunaire-v2/ へ退避済み。
// Spine 経路: ボールジョイント人形リグ lunaire-doll (idle/attack/parry/dodge/execute、奥側暗化込み)。
// 2026-06-07: 旧 skeleton.json → 新リグ skeleton_ik_skirt (IK 脚+分割スカート, ver4.3.16) へ統合。
//   execute(0.9s) を実機 Spine 再生。 execute_finisher は未実装のため drawSpinePlayer が false を返し
//   render.ts の frame-by-frame fallback に委ねる (トドメ致命は当面 旧描画・無破綻)。
// 2026-07-20: 受け構え (案C) を本番 skeleton へ清書済み = dev 専用の ?guardWip=1 迂回路は役目を終えて撤去。
preloadSpinePlayer('/sprites/lunaire-doll/', 'skeleton_ik_skirt.json', 'skeleton_ik_skirt.atlas')
preloadParryFlashes() // アニメ調パリィ閃光スプライト (additive)
preloadParryFamilyFx() // 受けた時の火花・砂ぼこり／崩した瞬間の閃光 (10-06・画像生成の素材)
preloadFinisherFx() // 致命FXスプライト (魔法陣ほか、 additive)
preloadSparkSprites() // 普段の致命の火花 (10-21 A案・src/luna_spark_fx.ts)。ほどける光の絵は ?lunaNormalFx=ribbon の時だけ読む
preloadLanceButtEruption() // lanceButt 石畳隆起スプライト
preloadKnightDustArt() // 騎士の飛び込みの砂ぼこり (見本から切り出した材料)
preloadKnightSpearTrail() // 騎士の切り下がりの槍の軌跡 (見本から切り出した材料)
preloadKnightSuriDust() // 騎士のすり足の床の砂 (見本から切り出した材料)
preloadBrideHazard() // 花嫁床技: poison_mist_v3 / veil_stream_v3 / thorn_growth_v3 (v3 rev2 透過 PNG)
preloadRampageGrudge() // 覚醒王「大暴れ」= 湧き出る怨嗟の塊 (本番でも出す)
preloadFloorWave()      // 大暴れ第5案の床技の割れ (絵の案・`?waveFx=art`)
preloadGrudgeOrbs()    // 大暴れ第5案の怨念 (床の帯と同じ画風・3色)
preloadParrySteel() // 🔔 冷たい銀パリィが芯に使う銀の剣戟ワンショットを先読み (本番・dev 共通)
preloadSfxSamples() // 🌀💨 見切り/回避の採用WAV を先読み (本番・dev 共通)
if (import.meta.env.DEV && finisherV2On()) preloadLunaFinisherSfx() // 主人公の致命の新しい版の音 (DEV ?lunaFinisher=new だけ・src/luna_finisher.ts)
if (lunaExecSwapOn()) preloadLunaAliceSfx() // 致命の入れ替えの音 (配布版 lamp・?lunaExec=old で前の版・src/luna_exec_swap.ts)
// 騎士の薙ぎの音の候補 (?sweepSound=a..t の時だけ・素材は git 外 public/sfx/candidates/)
if (import.meta.env.DEV && /[?&]sweepSound=([a-t])(&|$)/.test(location.search)) preloadKnightSweepCandidates()
if (import.meta.env.DEV && /[?&]knightTell=[a-c](&|$)/.test(location.search)) preloadKnightTellCandidates()
// パリィの音の候補 (?parrySound= / ?execParrySound= の時だけ・game.ts の DEV の箱が読んだ結果を見る・素材は git 外 public/sfx/candidates/)
if (import.meta.env.DEV && parrySoundCandidatesWanted()) preloadParrySoundCandidates()
// 連続の段と技の重さで変わるパリィの音の候補 (?parryPitch=p|q|r の時だけ・10-13・src/parry_pitch.ts)
if (import.meta.env.DEV && parryPitchVariant() !== 'off') preloadParryPitchSamples()
// パリィの音の作り直し (?parrySfx=・10-14・src/parry_remake.ts・配布版と付けない時は gb3 (10-17〜)・off で前の配布版の柳の型)。?parryPitch= より先に効く。
if (import.meta.env.DEV) setParryRemakeVariant(new URLSearchParams(location.search).get('parrySfx'))
// 得物の材質で版を使い分ける (10-18・配布版は金の爪と牙だけ gs3・ほかは gs1)。開発版だけ ?parryByWeapon=0 (または ?parrySfx=) で切り、?parryHeavy=gs4・?parryThin=gs2 で負けた案を聞き直す
if (import.meta.env.DEV) { const q = new URLSearchParams(location.search); setParryByWeapon(parseParryByWeapon(q.get('parryByWeapon'), q.get('parryHeavy'), q.get('parryThin'), q.get('parrySfx') !== null)) }
// 余韻 (配布版＝humWc・10-20)。開発版は ?parryTail=humW|humWa|humWb|hum… (唸り) / plate|plateShort|plateLow (板の響き) で比べ、?parryTail=off で余韻なし。得物で選んだ版の上に足す
if (import.meta.env.DEV) setParryTail(new URLSearchParams(location.search).get('parryTail') ?? PARRY_TAIL_RELEASE)
// 開発版だけ: ?sfxRoots=plain|bare で効果音の「楽器の層」を抜いて聞き比べる (10-17・src/sfx_roots.ts)。配布版は常に off
if (import.meta.env.DEV) setSfxRootsDev(new URLSearchParams(location.search).get('sfxRoots'))
if (import.meta.env.DEV && parryRemakeVariant() !== 'off') preloadParryRemakeSamples()
// 🔔 パリィ音 = ❄冷たい銀 で確定 (ユーザー裁定 2026-06-13)。 暖色への切替(旧 P キー)は撤去し固定。
//   実体は audio.ts parryColdEnabled=true。 暖色 playParry は参考に残置 (§2.1)。
// dev デバッグフック群: 本番ビルドには含めない (import.meta.env.DEV ガードで tree-shake)。
//   dev (npm run dev) では生きるので検収スクリプト(__freeze* 等)はそのまま動く。
//   __frozen は frame ループが参照するのでゲート外に置く。
let __frozen = false
if (import.meta.env.DEV) {
// 覚醒王「大暴れ」床FXの比較ツマミ。'off' で従来の儀式境界線へ戻す。
;(window as any).__rampageFx ??= 'a'
// dev デバッグフック (2026-08-23): 実機のステップを撮影スクリプトから読む (相・座標)。
;(window as any).__gameState = () => ({
  phase: state.phase, bossX: state.boss.x, playerX: state.player.x, bossState: state.boss.state,
  step: state.boss.exec?.step ? `${state.boss.exec.step.kind}/${state.boss.exec.step.phase}` : 'none',
  attack: state.boss.currentAttack?.id ?? null,
  bossElapsed: state.boss.stateElapsed,   // 構えの見比べの撮影用 (2026-09-29)
  executesTaken: state.boss.executesTaken,   // 検収パックの戦闘タイマーが幕の区切りに使う (2026-09-22)
  advCursor: state.adv?.cursor ?? null,   // 会話場面の撮影で、 文の行だけ送るため (2026-10-29)
})
;(window as any).__placeBoss = (x: number) => {
  state = { ...state, boss: { ...state.boss, x, state: 'idle', stateElapsed: 0, currentAttack: null,
    ...(state.boss.exec ? { exec: { ...state.boss.exec, step: null } } : null) } }
}
// dev デバッグフック (2026-10-14): ボスの体幹を満タンの ratio 倍に置く (崩した瞬間の撮影 scripts/capture_break_stop.mjs)。
;(window as any).__setPlayerStrain = (ratio: number, hitAgoSec: number | null = null) => {
  // dev デバッグフック (2026-10-30): 主人公の体幹と被弾の直後を置く (画面の赤の比較版の撮影 ?redSignals)。
  const fx = hitAgoSec == null ? state.fx : [...state.fx, { kind: 'damage_vignette' as const, t: state.time - hitAgoSec }]
  state = { ...state, fx, player: { ...state.player, posture: playerMaxPosture() * ratio } }
}
;(window as any).__setRoosterFrenzyStage = (stage: 0 | 1 | 2 | 3) => {
  // dev デバッグフック (2026-11-03): 鶏の焦り狂い (配布版) の段を直接置く (段の合図の撮影・比べる時に段3 から始める)。
  const st = state.boss.roosterFrenzy
  state = { ...state, boss: { ...state.boss, roosterFrenzy: { stage, inString: false, claws: 0, parries: 0, struck: false, breath: false, ...(st?.inString ? { inString: true, claws: st.claws, parries: st.parries, struck: st.struck } : null) } } }
}
;(window as any).__setBossPosture = (ratio: number) => {
  state = { ...state, boss: { ...state.boss, posture: state.boss.maxPosture * ratio } }
}
// 本編の単体戦でも、コンソール1行で画像キーごとの顔アンカーを調整できる器を先に置く。
;(globalThis as { __faceFix?: Record<string, [number, number]> }).__faceFix ??= {}
// 請われぬ介錯の剣先発光も、コンソール1行で [x, y] を調整できる器を先に置く。
;(globalThis as { __castFlashFix?: [number, number] | null }).__castFlashFix ??= null
// dev デバッグフック: 勝敗オーバーレイ等の検収用に phase を直接セット。
;(window as any).__setPhase = (phase: string, elapsed = 0) => {
  // elapsed 指定時は freeze してその経過秒で静止描画 (勝敗画面の reveal を狙った t で検収)。
  state = { ...state, phase: phase as typeof state.phase, finisher: null, phaseElapsedSec: elapsed }
  if (elapsed > 0) { __frozen = true; draw(ctx!, state) } else { __frozen = false }
}
// dev デバッグフック (2026-07-25 第4段-b 検収): 幕間2択の「出るまでの間」を指定時刻で静止描画する。
//   実時間で待つとスクショ1枚ぶんの処理時間だけ game 側の経過が進んでしまい、 フェードの途中を
//   狙って撮れない (実測: 200ms 待って choiceElapsedMs=633)。 経過を直接与えて1フレームだけ描く。
;(window as any).__freezeAdvChoice = (bossId: string, choiceElapsedMs: number, index = 0) => {
  const r = (window as any).__advChoice(bossId, index)
  if (!r) return
  state = { ...state, adv: state.adv ? { ...state.adv, choiceElapsedMs } : state.adv }
  __frozen = true
  draw(ctx!, state)
  return `${bossId} choiceElapsedMs=${choiceElapsedMs}`
}
// dev デバッグフック (P4 §死因 検収): defeat 画面を指定 elapsed で静止描画し、 死因 label を注入する。
//   実機では game.ts が deathBeat.causeLabel → lastDeathCause へ退避して描く。 ここはその最終表示だけを再現。
;(window as any).__freezeDefeat = (elapsed = 2.6, causeLabel = (null as string | null)) => {
  state = { ...state, phase: ('defeat' as const), finisher: null, deathBeat: null, phaseElapsedSec: elapsed, lastDeathCause: causeLabel }
  __frozen = true
  draw(ctx!, state)
}
// dev デバッグフック: 請われぬ介錯の刃/腕砲を実機で差し替える。
//   第2引数 startMorph=true で「変形アクション」を今すぐ始める (前半=後ろへ引く / 後半=組み変わる)。
//   held は変形の終了時に切り替わるので、startMorph の時は「いま持っている物」を渡す。
//   幕2でしか変形しないので、幕1で呼んだ時は executesTaken も 1 へ上げる (ラボ・検収用)。
//   例: __setExecWeapon('blade', true) → 刃で構えたまま後退 → 腕砲へ組み変わる
;(window as any).__setExecWeapon = (held: 'blade' | 'cannon' = 'blade', startMorph = false) => {
  const boss = state.boss
  if (!boss.exec) { console.warn('[setExecWeapon] いまのボスは刑吏ではない'); return }
  state = {
    ...state,
    boss: {
      ...boss,
      executesTaken: startMorph ? Math.max(1, boss.executesTaken) : boss.executesTaken,
      state: startMorph ? 'idle' : boss.state,
      stateElapsed: startMorph ? 0 : boss.stateElapsed,
      currentAttack: startMorph ? null : boss.currentAttack,
      exec: {
        ...boss.exec, held,
        morph: startMorph ? 'morphing' : 'no',
        morphElapsedMs: 0,
      },
    },
  }
  return `held=${held}${startMorph ? ' morph=morphing' : ''}`
}
// dev デバッグフック (2026-09-03 第3便): 榴弾の散り方 A/B を実機で切り替える。
//   例: __setMortarSpread('B') → 次の榴弾から B (隙間なしの一帯) で落ちる
;(window as any).__setMortarSpread = (id: 'A' | 'B') => setExecutionerMortarSpread(id)
// dev デバッグフック (2026-09-03 第4便): 砲の間合いを実機で切り替える。例: __setCannonRange(480)
;(window as any).__setCannonRange = (px: number) => setExecutionerCannonRange(px)
// dev デバッグフック (2026-09-04): 砲形態の噛み合わせ案を実機で切り替える (すぐ効く)。
//   例: __setCannonMode('shove') / __setCannonScore('single')。既定 = duel / composed (2026-09-06 ユーザー裁定)。
;(window as any).__setCannonMode = (mode: 'shove' | 'duel') => setExecutionerCannonMode(mode)
;(window as any).__setCannonScore = (score: 'composed' | 'single') => setExecutionerCannonScore(score)
// dev デバッグフック (2026-09-07 便1 拍の作り直し): 発勁の突きの溜め/一拍の3択を実機で切り替える。
;(window as any).__setFajinDraw = (draw: FajinDraw) => setFajinDraw(draw)
;(window as any).__setFajinBeat = (beat: FajinBeat) => setFajinBeat(beat)
// dev デバッグフック (2026-09-05): 砲形態の「時間の床」の長さを実機で切り替える。秒で受けて内部はミリ秒。
//   例: __setCannonHold(15) → 変形直後15秒は刃へ戻さない。既定20秒。
;(window as any).__setCannonHold = (sec: number) => setExecutionerCannonHoldMs(sec * 1000)
// dev デバッグフック (2026-09-05): 榴弾 (exec_cannonMortar) の落下列数を実機で切り替える。既定5列。
//   例: __setMortarRows(3) → 旧・横3列へ戻す
;(window as any).__setMortarRows = (rows: 3 | 5) => setExecutionerMortarRows(rows)
// dev デバッグフック (2026-09-06): 刃形態の連の中の「規則拍」(gapMs) を実機で切り替える (すぐ効く)。
//   例: __setBladeGap(480) → 旧値へ戻す / 既定260。900/780の「ワンテンポ」は対象外。
//   正本 = docs/candidates/2026-09-05-executioner-blade-tempo-fable-design.md §3-1
;(window as any).__setBladeGap = (ms: number) => setExecutionerBladeGapMs(ms)
// dev 実機比較 (2026-09-06): 回避は0で連打可能/既定500、芯はlegacyで幅28/既定real。
;(window as any).__setStepCooldown = (ms: number) => setStepCooldownMs(ms)
;(window as any).__setBossCore = (mode: BossCoreMode) => setBossCoreMode(mode)
// dev デバッグフック (2026-09-06 便1): ボスの「芯」を実測する。ゲーム本体と同じ描画式 (getSpriteMeta /
//   resolveBossSpriteScaleParams・sprites.ts) を呼ぶだけで、定数は一切コピーしない。
//   出所 = docs/candidates/2026-09-06-boss-core-real-size-fable-design.md §1-2。
//   使い方: __measureBossCore('the-executioner', 'cannon') → console.table で5帯を表示 (既定 key='idle')。
;(window as any).__measureBossCore = (bossId: string, variant: string | null = null, key: SpriteKey = 'idle') => {
  const displayHeight = bossDisplayHeightFor(bossId)
  const result = measureBossCoreBands(bossId, variant, key, displayHeight)
  if (!result) { console.warn(`[measureBossCore] 絵が未ロード: ${bossId}${variant ? '#' + variant : ''}/${key}`); return null }
  console.table(result.bands.map((b) => ({
    band: b.band, rows: b.rows,
    wideW_med: b.wideWMed?.toFixed(1) ?? '-', wideW_min: b.wideWMin?.toFixed(1) ?? '-', wideW_max: b.wideWMax?.toFixed(1) ?? '-',
    offset_med: b.offsetMed?.toFixed(1) ?? '-', centerInRun: b.centerInRunFrac !== null ? `${Math.round(b.centerInRunFrac * 100)}%` : '-',
    rowFullW_med: b.rowFullWMed?.toFixed(1) ?? '-',
  })))
  console.log(`[measureBossCore] ${bossId}${variant ? '#' + variant : ''}/${key} bbox=${result.bboxWidthPx.toFixed(1)}x${result.bboxHeightPx.toFixed(1)} bodyHalfWidthPx=${result.bodyHalfWidthPx.toFixed(1)} scale=${result.scale.toFixed(4)}`)
  return result
}
// dev デバッグフック (2026-09-04): 据えの突きの絵の候補 a/b/old を実機で切り替える (次の突きから)。
;(window as any).__setPierceArt = (art: 'a' | 'b' | 'old') => setExecutionerPierceArt(art)
// dev デバッグフック (2026-09-04): 突き当ての絵を切り替える。'old' = 蹴りの溜め+突き飛ばしの流用 / 'thrust' = 引き絞り+突き出し (既定)。
;(window as any).__setJabArt = (art: 'old' | 'thrust' | 'lunge') => setExecutionerJabArt(art)
;(window as any).__setAwokenBiteOrder = (o: AwokenBiteOrder) => setAwokenBiteOrder(o)
// dev デバッグフック (2026-09-03 第4便): 腕砲の弾の見た目を実機で切り替える。
//   例: __setShotLook('rock') → 旧・黒鉄の岩塊へ戻す / __setShotLook('orb') → 紫の光の玉 (既定)
;(window as any).__setShotLook = (look: 'orb' | 'rock') => setCannonShotLook(look)
// dev デバッグフック (2026-09-03 第5便): 地割りの床の演出を実機で切り替える。
//   例: __setQuakeLook('b') → 石牙 / 'c' → 呪いの噴出 / 'a' → 灼熱の地脈 (既定) / 'old' → 旧
;(window as any).__setQuakeLook = (look: 'a' | 'b' | 'c' | 'old') => setQuakeLook(look)
// dev デバッグフック: __setFajinLook('e') → 押し潰された空気（既定）/ 'f' → 打撃の残圧。
//   a/b/c/d/old も比較用に保持。
;(window as any).__setFajinLook = (look: FajinLook) => setFajinLook(look)
// dev デバッグフック (2026-09-10): 発勁の光波 d だけの色を実機で切り替える。
//   例: __setFajinTint('gold') → 参考画像の金白 / 'violet' → 作品の紫 (既定)
;(window as any).__setFajinTint = (tint: 'violet' | 'gold') => setFajinTint(tint)
// dev デバッグフック (2026-09-03 第8便): 砲身薙ぎ (exec_cannonSweep) の構えの絵の候補を実機で切り替える。
//   例: __setSweepWindup('twist_a') → 候補 twist_a / 'mortar' → 旧仮 (榴弾の構え流用)。既定 = twist_a (第8便 採用)。
;(window as any).__setSweepWindup = (look: ExecutionerSweepWindupLook) => {
  setExecutionerSweepWindupTimeline(look)
  setSpriteFileOverride('the-executioner', 'cannon', 'sweep_windup', look === 'mortar' ? null : `sweep_windup_${look}`)
  clearBossSpriteCache('the-executioner')
  preloadBossSprites('the-executioner')
  console.log(`[sweepWindup] ${look}`)
}
// dev デバッグフック (2026-08-14): 主人公を任意の位置へ置く。
//   出所 = docs/candidates/2026-08-14-executioner-cannon-shot-physical-ticket.md §7-1。
//   🔴 これが無いと**飛翔体の写真が1枚も撮れない**。__soloAttack で撃たせても主人公とボスが
//      密着したままなので、発射と着弾が同じコマに来る (0.10倍のゆっくり再生でも同じ)。
//   使い方: __placePlayer(180) → 絶対 x へ。__placePlayer({ fromBoss: 400 }) → ボスから 400px 手前へ。
//   ⚠️ ボスに近い側 (ボスの向いている側) へ置く。ボスは自分から後退しないので、
//      技の telegraph に入った後で呼べば active 中は距離が保たれる。
//   ⚠️ 位置を置くだけ = 速度・状態・入力には触らない。壁 (arenaBoundsFor) だけでクランプする。
;(window as any).__placePlayer = (arg: number | { fromBoss: number }) => {
  const boss = state.boss
  const walls = arenaBoundsFor(boss.id)
  const raw = typeof arg === 'number'
    ? arg
    // ボスは主人公を向いているので、facing 側 = 主人公がいる側。そこへ dist だけ離して置く。
    : boss.x + (boss.facing === 'right' ? 1 : -1) * Math.abs(arg.fromBoss)
  const x = Math.max(walls.leftWall, Math.min(walls.rightWall, raw))
  state = { ...state, player: { ...state.player, x } }
  const clamped = x !== raw
  return { playerX: Math.round(x), bossX: Math.round(boss.x), dist: Math.round(Math.abs(boss.x - x)),
    clamped, walls }
}
// dev デバッグフック (2026-10-02): 主人公の連撃の段と経過 ms を指定して止めて描く (描いたコマの位置合わせの検収用)。
//   step = 0〜2。ms < 0 で凍結を解く。3段目の踏み込みで動いた体の位置もゲームと同じ曲線で再現する。
;(window as any).__freezePlayerAttack = (step: number, ms: number) => {
  if (ms < 0) { __frozen = false; return }
  const base = (window as any).__freezePlayerAttackBaseX ??= state.player.x
  const dir = state.player.facing === 'right' ? 1 : -1
  const x = base + dir * heavyLungeTravelPx(step, ms)
  state = { ...state, player: { ...state.player, x, state: 'attacking', stateElapsed: ms / 1000,
    attackComboStep: step, attackIsCounter: false, attackContactKind: null } }
  __frozen = true
  draw(ctx!, state)
}
// dev デバッグフック (10-19・撮影用): 止め (アリスの技・?lunaExec=swap) の見た目の時計 (ms)・撃破の時計・止めの残り・ボスの状態。
;(window as any).__aliceClock = () => ({ clock: aliceClockMs(state), fin: state.finisher?.elapsedMs ?? null,
  hitStop: state.hitStopRemaining, boss: state.boss.state, timeScale: state.timeScale })
// dev デバッグフック: 現在のボスを致命トドメ確定状態へ強制遷移させる (FX 検収用)。
;(window as any).__forceLethal = () => {
  state = {
    ...state,
    boss: { ...state.boss, hp: 1, posture: state.boss.maxPosture, state: 'staggered' },
    player: { ...state.player, state: 'executing', executeHitIndex: 2,
      stateElapsed: (EXECUTE.perHitDurationMs * 2 + EXECUTE.perHitActiveStartMs + 5) / 1000,
      attackHitConsumed: false, x: state.boss.x - 40 },
  }
}
// dev デバッグフック: トドメ致命 (execute_finisher) を F0 から実戦同様に再生する。
//   ボスを崩し+低HP(=finisher 確定)にし、 プレイヤーを dist[px] 離して executing/finisher へ。
//   用途: ①単発化(A)の確認 ②立ち上がり~刺し保持~魂吸収を通しで観察 ③位置補正(C)の刺し距離 D 探し。
//   例: __finisherDemo(90) → 90px の距離で再生。 数値を変えて「刺さって見える D」を探す。
;(window as any).__finisherDemo = (startDist?: number) => {
  const bx = state.boss.x
  const anchor = state.boss.finisherAnchorOffset // ボス固有の刺し距離 (竜=130, 既定120)
  // 既定は anchor より少し遠くから開始 → C の吸着 (anchorEaseMs で寄る) を観察できる。
  const startX = bx - (startDist ?? anchor + 80)
  state = {
    ...state, phase: 'playing', finisher: null, timeScale: 1,
    boss: { ...state.boss, hp: 40, posture: state.boss.maxPosture, state: 'staggered', x: bx },
    player: {
      ...state.player, x: startX, facing: 'right',
      state: 'executing', executeVariant: 'finisher',
      executeHitIndex: 0, stateElapsed: 0, attackHitConsumed: false,
      executeAnchorX: bx - anchor, executeAnchorFromX: startX,
    },
  }
  console.log('[finisherDemo] start=' + startX + ' → anchor=' + (bx - anchor) + ' (offset ' + anchor + ') 吸着→刺し→魂吸収')
}
// dev デバッグフック: パリィ閃光を任意位置に1発出す (FX 検収用)。
;(window as any).__testParry = (intensity = 1) => {
  state = { ...state, fx: [...state.fx, { kind: 'parry_spark', x: 760, y: 210, t: state.time, intensity }] }
}
// dev デバッグフック: パリィ閃光を指定 age(秒)で静止描画 (headless はシムが飛び一瞬の閃光を撮れないため)。

// dev デバッグフック: トドメ演出を任意の elapsedMs で静止描画する (短いビートの検収用)。
// シミュレーションを止め、 finisher.elapsedMs を直接置いて 1 フレームだけ描く。
;(window as any).__freezeParry = (age = 0.03, intensity = 1) => {
  __frozen = true
  state = { ...state, fx: [{ kind: 'parry_spark', x: 760, y: 210, t: state.time - age, intensity }] }
  draw(ctx!, state)
}
;(window as any).__freezeFinisher = (elapsedMs: number) => {
  __frozen = true
  ;(window as any).__forceLethal()
  // ボスと主人公を一定間隔に離して固定 (魂糸が見えるよう、 AI 接近の影響を排除)
  const bx = 680, py = ARENA.floorY
  state = {
    ...state,
    boss: { ...state.boss, x: bx, y: py },
    player: { ...state.player, x: bx - 80, y: py },
    finisher: { elapsedMs, bossX: bx, bossY: py },
  }
  draw(ctx!, state)
}
// dev デバッグフック: 処刑死の浄化シネマティック (#2) を任意 elapsedMs で静止描画 (短いビートの検収用)。
//   deathBeat.execution=true を直接置いて 1 フレームだけ描く。 elapsedMs を変えて 白の一拍→魂の放出→
//   常夜燈への帰還までをスクラブできる。
;(window as any).__freezeExecDeath = (elapsedMs = 600) => {
  __frozen = true
  state = {
    ...state, phase: 'playing', finisher: null, timeScale: 1,
    player: { ...state.player, x: 480, y: ARENA.floorY },   // deathBeat 存在で render が defeat ポーズへ
    deathBeat: { elapsedMs, motionDoneAtMs: 0, execution: true, causeLabel: undefined },
  }
  draw(ctx!, state)
}
// dev: 致命の世界観カラーを実機で切替 (#12)。A=空間は常時。__setExecWorld('A')=確定/'AB'=結晶足す/'ABC'=全部。
;(window as any).__setExecWorld = (key = 'A') => {
  setExecWorldColors(key.includes('B'), key.includes('C'))
  return `exec world color = ${key} (A=空間は常時) — 致命を出して聞き比べて`
}
// dev: 魂③ のテイクを実機で切替 (#12 ③ 既定=off 無音)。off / E=吐息x3 / F=空気x2 / old=旧弦声。
;(window as any).__setSoulTake = (v: 'off' | 'e1' | 'e2' | 'e3' | 'f1' | 'f2' | 'old_strings' = 'off') => {
  setSoulTake(v)
  return `soul take = ${v} (off=無音/既定 / E=吐息 / F=空気 / old=旧弦声) — 騎士を撃破して pull で確認`
}
// dev: 魂③ の音量を実機で調整 (#12 ③・偶発系は静かなので沈むなら1.2まで上げる)。既定0.95。
;(window as any).__setSoulVoice = (v = 0.95) => {
  setSoulVoice(v)
  return `soul voice = ${v} (沈むなら1.2まで上げる)`
}
// dev: 防御3段 (ガード / 通常パリィ / ジャストパリィ) を単体で鳴らす。
//   ★実際の再生経路 (playSfx) をそのまま通す = 聞き比べ用に別実装を作らない。
//   録音は scripts/record_parry_tiers.mjs が __devCaptureStream と組み合わせて行う。
;(window as any).__playDefenseSfx = (kind: 'guard' | 'parry' | 'just', intensity = 1) => {
  ensureAudio()
  if (kind === 'guard') playSfx('guard_player')
  else playSfx('parry', intensity, kind === 'just')
  return `played ${kind} (intensity=${intensity})`
}
// dev: パリィの音の候補 (10-09・src/parry_sound.ts) をその場で切り替える / 単体で鳴らす (聞き比べ・録音 scripts/record_parry_sound_candidates.mjs)。
//   __setParrySound('a'|'b'|'c'|'now', 'a'|'b'|'c'|'now') = 普段 / 致命を弾いた時 (now = 旧の音・null = 配布版の既定 a / b)。__playParrySound({ exec, intensity, isJust }) は実際の再生経路 (playPending) を通す。
;(window as any).__setParrySound = (normal: string | null = null, exec: string | null = null) => {
  const n = setParrySoundVariant(normal)
  const x = setExecParrySoundVariant(exec)
  preloadParrySoundCandidates()
  ensureAudio()
  return `parry sound = ${n} / exec = ${x}`
}
// dev: 好きな効果音を実際の再生経路で1つ鳴らす (聞き比べで今の振り・命中と並べるため)。
;(window as any).__playSfx = (id: Parameters<typeof playSfx>[0]) => { ensureAudio(); playSfx(id); return `played ${id}` }
;(window as any).__playParrySound = (opts: { exec?: boolean; intensity?: number; isJust?: boolean; chain?: number; weight?: number; broke?: boolean; attackId?: string; material?: ParryMaterial } = {}) => {
  __devPlayParry({ exec: !!opts.exec, intensity: opts.intensity ?? 1, isJust: opts.isJust ?? true,
    pitch: { chain: opts.chain ?? 1, weight: opts.weight ?? 0.3, broke: !!opts.broke, attackId: opts.attackId, material: opts.material } })
  return 'played'
}
// dev: 連続の段と技の重さで変わるパリィの音の候補 (10-13・src/parry_pitch.ts) をその場で切り替える。'off' = 今の音。
;(window as any).__setParryPitch = (v: string | null = null) => {
  const r = setParryPitchVariant(v)
  preloadParryPitchSamples()
  ensureAudio()
  return `parry pitch = ${r}`
}
// dev: パリィの音の作り直し (10-14・src/parry_remake.ts) をその場で切り替える。'off' = 今の音。
//   __playParrySound({ attackId: 'houndTripleSlam' }) で技から材質と重さを引いて鳴らす ({ material, weight } で直に指定も可)。
;(window as any).__setParrySfx = (v: string | null = null) => {
  const r = setParryRemakeVariant(v)
  preloadParryRemakeSamples()
  ensureAudio()
  return `parry sfx = ${r}`
}
// dev: 得物の材質で版を使い分ける (10-18・配布版は入り)。__setParryByWeapon(true, 'gs4', 'gs2') / __setParryByWeapon(false) で切る
;(window as any).__setParryByWeapon = (on = true, heavy: string | null = null, thin: string | null = null) => {
  const r = setParryByWeapon(parseParryByWeapon(on ? '1' : '0', heavy, thin))
  ensureAudio()
  return `parry by weapon = ${r.on ? `on heavy=${r.heavy} thin=${r.thin}` : 'off'}`
}
// dev: 余韻を足した比較版 (src/parry_remake.ts)。__setParryTail('hum'|'humLine'|'humSway'|'plate'|'plateShort'|'plateLow') / __setParryTail(null) で外す (既定は humWc)
;(window as any).__setParryTail = (v: string | null = null) => {
  const r = setParryTail(v)
  ensureAudio()
  return `parry tail = ${r ?? 'off'}`
}
// dev: 効果音の「楽器の層」を抜いた版 (10-17・src/sfx_roots.ts)。'off' = 配布版のまま / 'plain' / 'bare'
;(window as any).__setSfxRoots = (v: string | null = null) => {
  const r = setSfxRootsDev(v)
  ensureAudio()
  return `sfx roots = ${r}`
}
// dev: 実出力 (limiter の後) を MediaStream として取り出す。音の変更を「文章」でなく実音で渡すため。
;(window as any).__devCaptureStream = () => __devCaptureStream()
// dev デバッグフック: 指定 index/id のボスで playing を初期化 (bride 等の体感検収用)。
//   例: __setBoss('bride') / __setBoss(1)。 frame ループがボス切替を検出してスプライト/BGMを自動ロードする。
;(window as any).__setBoss = (idOrIndex: string | number) => {
  const idx = typeof idOrIndex === 'number'
    ? idOrIndex
    : BOSS_DEFINITIONS.findIndex((b) => b.id === idOrIndex)
  if (idx < 0 || idx >= BOSS_DEFINITIONS.length) { console.warn('[setBoss] not found:', idOrIndex); return }
  // 下書き印つき (2026-07-26): 開発中に自分の本物のセーブを壊さないため。
  state = { ...createInitialState({ ...createScratchCampaign(), currentBossIndex: idx }), phase: 'playing' }
  __frozen = false
}
// dev デバッグフック: 体幹・HP経済 A/B プリセット切替 (C:/dev/LUNAIRE-notes/reports/2026-07-03-hp-posture-economy-tuning.md)。
//   v2=既定 (2026-07-04 デフォルト昇格・econ.ts) / v1=旧経済 (balance.ts の素の値)。 ボスHP/部屋は次のスポーンから反映。
;(window as any).__econ = (p: 'v1' | 'v2') => {
  setEconPreset(p)
  console.log(`[econ] preset=${p}。ボスHP/部屋は次のスポーンから反映 → __setBoss('vigil-knight') で再出現させて`)
}
// dev デバッグフック (2026-07-20): ボスの歩速倍率を実機で A/B する。
//   boss.ts:205 は毎フレーム getBossDefinitionById を読むので、定義側を書き換えると即反映される
//   (再スポーン不要)。検収で「今の速さ vs 変更後」を並べて比べるためだけの道具。
//   例: __walkMul('nameless-shade', 0.6) → 元に戻す = __walkMul('nameless-shade', null)
// dev デバッグフック (2026-07-21): ADV の2択画面を直接出す (可読性の検証・撮影用)。
//   幕間を頭から流さずに「本文が全部出て選択待ち」の状態へ飛ぶ。
//   例: __advChoice('inverted-jester') / __advChoice('bride', 1) = 2つ目を選んだ状態
// dev デバッグフック (2026-07-21): 戦闘前ADV を「本文が全部出た」状態で出す。
//   例: __advPre('former-princess') = 20行の最長場面
;(window as any).__advPre = (bossId: string, cursor?: number) => {
  const idx = BOSS_DEFINITIONS.findIndex((b) => b.id === bossId)
  // 下書き印つき (2026-07-26): 開発中に自分の本物のセーブを壊さないため。
  const campaign = { ...createScratchCampaign(), currentBossIndex: Math.max(0, idx) }
  const scene = getPreBattleScene(bossId, campaign)
  if (idx < 0 || !scene) { console.warn('[advPre] 戦闘前ADVが無い:', bossId); return }
  state = {
    ...createInitialState(campaign), phase: 'preBattle', phaseElapsedSec: 1,
    adv: { ...startScene(scene), cursor: cursor ?? scene.lines.length - 1 },
  }
  __frozen = false
  // state だけ差し替えて lastTime を据え置くと、次フレームの frameDt が古い時刻からの
  //   ギャップ分だけ膨らみ、fixed tick が一気にバースト処理される (誤爆ガードの検証等で
  //   経過時間が実時間とズレる原因になる・2026-07-25 発見)。 直前の値へ揃えて次tickから正確に刻む。
  lastTime = performance.now() / 1000
  accumulator = 0
  return `${bossId} の戦闘前ADV (${scene.lines.length}行)`
}
;(window as any).__advChoice = (bossId: string, index = 0) => {
  const idx = BOSS_DEFINITIONS.findIndex((b) => b.id === bossId)
  const scene = getInterludeScene(bossId)
  if (idx < 0 || !scene.choice) { console.warn('[advChoice] 2択が無い:', bossId); return }
  // 下書き印つき (2026-07-26): 開発中に自分の本物のセーブを壊さないため。
  state = {
    ...createInitialState({ ...createScratchCampaign(), currentBossIndex: idx }),
    phase: 'interlude', phaseElapsedSec: 1,
    adv: { ...startScene(scene), cursor: scene.lines.length - 1, choosing: true, choiceIndex: index },
  }
  __frozen = false
  // 上の __advPre と同じ理由で lastTime/accumulator を揃える。
  lastTime = performance.now() / 1000
  accumulator = 0
  return `${bossId} の2択 (index=${index})`
}
// dev デバッグフック (2026-11-04): 撃破後の場面を、 文に text を含む行で止める (文言の比較版の撮影用)。 例: __advLine('vigil-knight', '兜')
;(window as any).__advLine = (bossId: string, text: string) => {
  const idx = BOSS_DEFINITIONS.findIndex((b) => b.id === bossId)
  const scene = getInterludeScene(bossId)
  const at = scene.lines.findIndex((l) => 'text' in l && l.text.includes(text))
  if (idx < 0 || at < 0) { console.warn('[advLine] その行が無い:', bossId, text); return }
  state = {
    ...createInitialState({ ...createScratchCampaign(), currentBossIndex: idx }),
    phase: 'interlude', phaseElapsedSec: 1,
    adv: { ...startScene(scene), cursor: at },
  }
  __frozen = false
  lastTime = performance.now() / 1000
  accumulator = 0
  return `${bossId} の行${at}`
}
// dev デバッグフック (2026-10-29): 2択の続きの終わり (ボスが光になって消える所) だけを流す。 例: __advVanish('vigil-knight', 1)
;(window as any).__advVanish = (bossId: string, index = 0) => {
  const idx = BOSS_DEFINITIONS.findIndex((b) => b.id === bossId)
  const scene = getInterludeScene(bossId)
  const lines = scene.choice?.options[index]?.resultLines
  if (idx < 0 || !lines) { console.warn('[advVanish] 2択が無い:', bossId); return }
  // 消えの前の、 最後の文の次 (人物を外す・絵を出す・寄りを戻す・間) から。
  const dis = lines.findIndex((l) => l.kind === 'stage' && l.effect === 'dissolve')
  let at = dis
  while (at > 0 && ['figure', 'picture', 'stage', 'beat'].includes(lines[at - 1]!.kind)) at--
  state = {
    ...createInitialState({ ...createScratchCampaign(), currentBossIndex: idx }),
    phase: 'interlude', phaseElapsedSec: 1,
    adv: { ...startScene(scene), choiceResolved: true, resultLines: lines, cursor: at },
  }
  __frozen = false
  lastTime = performance.now() / 1000
  accumulator = 0
  return `${bossId} の消え (index=${index}, 行${at}から)`
}
// dev デバッグフック (2026-10-27): 撃破後の場面を最初の行から、 本物の進行のまま流す (先代なら回想→5秒の選択→終幕まで通る)。
//   ?advPreview は撃破後の場面で止まるので、 終幕へ続く流れはこちらで確かめる。 例: __advAfter('former-princess')
;(window as any).__advAfter = (bossId: string) => {
  const idx = BOSS_DEFINITIONS.findIndex((b) => b.id === bossId)
  if (idx < 0) { console.warn('[advAfter] そのボスは居ません:', bossId); return }
  const scene = getInterludeScene(bossId)
  preloadAdvPictures(scene)
  // 下書き印つき: 開発中に自分の本物のセーブを壊さないため。 本物と同じく撃破済みにしておく (最後のボスなら終幕へ進む)。
  const defeatedBossIds = BOSS_DEFINITIONS.slice(0, idx + 1).map((b) => b.id)
  state = {
    ...createInitialState({ ...createScratchCampaign(), currentBossIndex: idx, defeatedBossIds }),
    phase: 'interlude', phaseElapsedSec: 0, adv: startScene(scene),
  }
  __frozen = false
  lastTime = performance.now() / 1000
  accumulator = 0
  return `${bossId} の撃破後 (${scene.lines.length}行)`
}
// dev デバッグフック (2026-07-21): 配布版の区切り (「つづく」で終わるボス) を切り替える。
//   既定は覚醒獣 (= campaign.ts DEMO_FINAL_BOSS_ID・11-01)。 覚醒獣より先まで通しで遊びたい時は
//   __demoEnd(null) で解除する。
//   🔴 2026-08-07 訂正: ~~「既定は騎士」~~ は 2026-07-24 の騎士↔花嫁 入替より前の記述。
//   例: __demoEnd(null) / __demoEnd('the-executioner') / 現在値の確認 = __demoEnd()
;(window as any).__demoEnd = (id?: string | null) => {
  if (id !== undefined) setDemoFinalBossId(id)
  return `配布版の区切り = ${getDemoFinalBossId() ?? '無し (全ボス通し)'}`
}
;(window as any).__feedback = () => readFeedbackDraft()
;(window as any).__spineTrack = () => debugSpineTrack()
;(window as any).__walkMul = (bossId: string, mul: number | null) => {
  const def = BOSS_DEFINITIONS.find((b) => b.id === bossId)
  if (!def) {
    console.warn('[walkMul] ボスが見つからない:', bossId, '— 例: nameless-shade / vigil-knight')
    return
  }
  if (mul === null) delete (def as { walkSpeedMul?: number }).walkSpeedMul
  else (def as { walkSpeedMul?: number }).walkSpeedMul = mul
  const base = 270   // BOSS.walkSpeed
  console.log(`[walkMul] ${bossId} = ${mul ?? '未設定(1.0)'} → 約 ${Math.round(base * (mul ?? 1))}px/s`)
}
// dev デバッグフック (2026-07-07): パリィ長押しガード プロトタイプ A/B トグル (デフォルトOFF)。
//   docs/superpowers/plans/2026-07-07-parry-hold-guard-prototype.md。 __guard(true) でパリィを
//   押しっぱなしにするとガード状態=弾けなかった近接をチップHP+自体幹増で受け止める (赤オーラ攻撃は貫通)。
//   __guard(false) で既定 (従来と識別不能)。 採否は騎士+覚醒王で A/B して決める。
;(window as any).__guard = (on = true) => {
  setGuardEnabled(on)
  console.log(`[guard] パリィ長押しガード ${on ? 'ON' : 'OFF (既定)'}。パリィ押しっぱなし=弾けなかった近接をチップ受け止め・赤(弾けない)は貫通。`)
}
// dev 検収用: ガードの体幹連動を低・中・高で止めて撮る。戦闘規則/座標は変えない。
;(window as any).__freezeGuardVisual = (postureRatio = 0) => {
  const ratio = Math.max(0, Math.min(1, postureRatio))
  state = { ...state, phase: 'playing', player: { ...state.player, state: 'guarding', posture: ratio * PLAYER.maxPosture } }
  __frozen = true
  draw(ctx!, state)
}
// dev デバッグフック: 攻撃プールを1技へ固定 (技単独検証・処刑人 技構成パック 2026-07-05)。
//   baseAttackIds 未登録の技 (B4/B5/C7/D8/D9) も直接出せる。解除 = __soloAttack(null)。
//   例: __setBoss('the-executioner'); __soloAttack('exec_maulSet')
;(window as any).__soloAttack = (attackId: string | null = null) => {
  if (attackId !== null && !ATTACKS[attackId]) {
    console.warn('[soloAttack] not found:', attackId, '— 例: exec_maulDrop')
    return
  }
  setDebugSoloAttack(attackId)
  // strings 持ちボス (騎士/花嫁/覚醒王) は連が単技プールを迂回する → solo 中は strings をバイパス。
  setDebugBypassStrings(attackId !== null)
  console.log(attackId ? `[soloAttack] ${attackId} だけ出すよ (解除 = __soloAttack(null))` : '[soloAttack] 解除 → 通常プール')
}
// dev デバッグフック (2026-07-07 覚醒王): 連 (string) を1本へ固定。 解禁より優先 = 幕3の連も幕1から出せる。
//   例: __setBoss('crowned-king-awoken'); __soloString('ak-rush-chase')。 解除 = __soloString(null)。
;(window as any).__soloString = (stringId: string | null = null, wallHunt?: 'v2' | 'old', wallHuntAim?: 'fixed' | 'aim' | 'half', wallHuntSpirits?: 'on' | 'off') => {
  if (wallHuntAim !== undefined) setWallHuntAim(wallHuntAim)
  if (wallHuntSpirits !== undefined) setWallHuntSpirits(wallHuntSpirits)
  if (wallHunt !== undefined) {
    setWallHuntGame(wallHunt === 'v2')
    state = { ...state, hits: [], boss: { ...state.boss, state: 'idle', stateElapsed: 0,
      currentAttack: null, currentString: null, wallHunt: undefined, altitudePx: 0 } }
  }
  setDebugSoloString(stringId)
  console.log(stringId ? `[soloString] ${stringId} だけ出すよ (解除 = __soloString(null))` : '[soloString] 解除 → 通常抽選')
}
// dev デバッグフック: ボス別の DEVプロキシ ⇔ 本番の絵。既定 OFF、false = 本番の絵。
;(window as any).__bossProxy = (bossId: string, on = true) => {
  setBossProxyEnabled(bossId, on)
  clearBossSpriteCache(bossId)
  preloadBossSprites(bossId)
  console.log(`[bossProxy] ${bossId}: ${on ? 'DEVプロキシ表示' : '本番の絵を表示'}`)
}
;(window as any).__awokenProxy = (on = true) => (window as any).__bossProxy('crowned-king-awoken', on)
// dev デバッグフック: 指定部屋 (executesTaken) の状態から開始 (lanceCross 等の部屋2解禁技の検収用)。
//   例: __setBossRoom('vigil-knight', 1) で部屋2 (executesTaken=1) から開始。
//   __setBoss と異なり executesTaken を上書きするだけ (HP/体幹は満タン)。
;(window as any).__setBossRoom = (idOrIndex: string | number, executesTaken = 1) => {
  const idx = typeof idOrIndex === 'number'
    ? idOrIndex
    : BOSS_DEFINITIONS.findIndex((b) => b.id === idOrIndex)
  if (idx < 0 || idx >= BOSS_DEFINITIONS.length) { console.warn('[setBossRoom] not found:', idOrIndex); return }
  const base = { ...createInitialState({ ...createCampaign(), currentBossIndex: idx }), phase: 'playing' as const }
  state = { ...base, boss: { ...base.boss, executesTaken } }
  __frozen = false
}
// dev デバッグフック: 現在のボスを宵渡り (blink=瞬間移動) に即突入させる (花嫁の渦FXの目視確認用)。
//   通常は「待機0.5秒+確率」でしか出ないので検収しづらい → これで何度でも再生できる。
//   例: __setBoss('bride'); __brideBlink()。 繰り返し呼べば毎回 消失→反対側へ再出現 が走る。
;(window as any).__brideBlink = () => {
  state = { ...state, boss: { ...state.boss, state: 'blink', stateElapsed: 0, currentAttack: null } }
  __frozen = false
}
// dev デバッグフック: 花嫁のワープ分岐 (1撃 / 3撃) を指定して「再出現の最初のフレーム」から再生する。
//   通常は blink の抽選任せで狙った分岐を出せず、モーション検収が運になるため。
//   ★ __freezeBossAttack は updateBossSpriteRuntime を通らず、 コード側の手続き的な動き
//     (変位・揺れ・拡縮) が一切映らない。 こちらは通常ループを走らせて実際に時間を進めるので、
//     予備動作を含めた本物の見え方が撮れる (AGENTS.md §9「動きを変えたらGIFで見せる」の土台)。
//   使い方: __setBossRoom('bride'); __brideBranchReplay('triple')
;(window as any).__brideBranchReplay = (branch: 'single' | 'triple' = 'single') => {
  const def = BOSS_DEFINITIONS.find((b) => b.id === 'bride')
  const str = def?.strings?.find((s) => s.id === `bride-blink-${branch}`)
  if (!str) { console.warn('[brideBranchReplay] string not found:', branch); return }
  const atk = getAttack(str.beats[0]!.attackId)
  const bx = 680, py = ARENA.floorY
  state = {
    ...state,
    phase: 'playing',
    boss: {
      ...state.boss, x: bx, y: py, facing: 'left',
      state: 'reappear', stateElapsed: 0,
      currentString: str, currentAttack: atk, beatIndex: 0, comboHitIndex: 0,
    },
    player: { ...state.player, x: bx - 220, y: py, facing: 'right' },
  }
  __frozen = false
}
// dev デバッグフック: ボスの指定攻撃を指定 phase (0..1=telegraph, 1..2=active, 2..3=recovery) で静止描画。
//   攻撃モーションの判別性 (噛みつき vs 突進牙) を検収するため。
//   2026-07-05: recovery (2..3) を追加 (処刑人キーポーズ検収=振り抜き/大反撃窓の絵を静止確認するため)。
;(window as any).__freezeBossAttack = (attackId: string, phase = 1.5) => {
  __frozen = true
  const atk = getAttack(attackId)
  const bx = 560, py = ARENA.floorY
  let bossState: 'telegraph' | 'active' | 'recovery'
  let stateElapsed: number
  if (phase <= 1) {
    bossState = 'telegraph'
    stateElapsed = (Math.sqrt(Math.max(0, phase)) * atk.chargeMs) / 1000
  } else if (phase <= 2) {
    bossState = 'active'
    const ap = Math.min(1, phase - 1)
    const l = 1 - Math.sqrt(1 - ap)
    stateElapsed = (l * atk.activeMs) / 1000
  } else {
    bossState = 'recovery'
    const ap = Math.min(1, phase - 2)
    stateElapsed = (ap * atk.recoveryMs) / 1000
  }
  state = {
    ...state,
    boss: { ...state.boss, x: bx, y: py, facing: 'left', state: bossState, stateElapsed, currentAttack: atk },
    player: { ...state.player, x: bx - 200, y: py, facing: 'right' },
    // 動画クリップ経路 (Phase 1) を検収で通すため clipKey を直接合わせる
    // (このフックは updateBossSpriteRuntime を経由しないため)。
    bossSprite: { ...state.bossSprite, clipKey: `attack:${attackId}`, clipElapsedMs: 0, parriedClipRemainingMs: 0 },
  }
  draw(ctx!, state)
}
// dev デバッグフック: 連撃の hit N を静止描画 (2026-07-06 バッチ2検収)。
//   __freezeBossAttack は phase 0..3 (telegraph/active/recovery) のみで comboGap/hitIndex を扱えない。
//   sub='active' で hitIndex の打点、 sub='gap' でその直後の comboGap (進行度 prog 0..1) を出す。
;(window as any).__freezeBossComboHit = (attackId: string, hitIndex: number, sub: 'active' | 'gap' = 'active', prog = 0.5) => {
  __frozen = true
  const atk = getAttack(attackId)
  const bx = 560, py = ARENA.floorY
  const bossState = sub === 'active' ? ('active' as const) : ('comboGap' as const)
  const durMs = sub === 'active' ? atk.activeMs : (atk.comboGapsMs?.[hitIndex] ?? atk.comboGapMs ?? 300)
  const stateElapsed = (Math.max(0, Math.min(1, prog)) * durMs) / 1000
  state = {
    ...state,
    boss: { ...state.boss, x: bx, y: py, facing: 'left', state: bossState, stateElapsed, currentAttack: atk, comboHitIndex: hitIndex },
    player: { ...state.player, x: bx - 200, y: py, facing: 'right' },
    bossSprite: { ...state.bossSprite, clipKey: `attack:${attackId}`, clipElapsedMs: 0, parriedClipRemainingMs: 0 },
  }
  draw(ctx!, state)
}
// dev デバッグフック: ボスを staggered (体幹崩れ) で静止描画。 elapsedSec で staggered_enter/hold の
//   二段ポーズを検収 (処刑人キーポーズ検収 2026-07-05)。
;(window as any).__freezeStaggered = (elapsedSec = 0.4) => {
  __frozen = true
  const bx = 560, py = ARENA.floorY
  state = {
    ...state,
    phase: 'playing',
    player: { ...state.player, x: bx - 200, y: py, facing: 'right', hp: PLAYER.maxHp },
    boss: { ...state.boss, x: bx, y: py, facing: 'left', state: 'staggered', stateElapsed: elapsedSec, currentAttack: null },
  }
  draw(ctx!, state)
}
// dev デバッグフック (2026-10-10・撮影用): 幕1でボスを好きな位置で崩れさせ、主人公を好きな位置に置いて動かし始める。
//   致命を入れると本物の幕の移り (致命 → 静止 → 幕2の確定初手) がそのまま走る。scripts/capture_exec_roar_center.mjs が使う。
//   3つ目の executesTaken を渡すと、その部屋から崩れる (10-12・最後の一撃の検収 = roomCount - 1)。 名乗りの途中なら飛ばす。
;(window as any).__staggerAt = (bossX: number, playerX: number, executesTaken = 0) => {
  const py = ARENA.floorY
  state = {
    ...withBossIntroDone(state),
    phase: 'playing',
    hits: [],
    player: { ...state.player, x: playerX, y: py, facing: playerX < bossX ? 'right' : 'left', hp: PLAYER.maxHp },
    boss: { ...state.boss, x: bossX, y: py, facing: playerX < bossX ? 'left' : 'right', state: 'staggered', stateElapsed: 0,
      currentAttack: null, executesTaken, posture: state.boss.maxPosture,
      ...(state.boss.exec ? { exec: { ...state.boss.exec, step: null } } : null) },
  }
  __frozen = false
}
// dev デバッグフック: ボスを idle で静止描画 (hp満タン・phase強制playing)。 __setBoss 直後は
//   永続セーブの player.hp が持ち越されて即 defeat 化することがあるため、 検収スクショではこちらを使う。
;(window as any).__freezeIdle = () => {
  __frozen = true
  const bx = 560, py = ARENA.floorY
  state = {
    ...state,
    phase: 'playing',
    player: { ...state.player, x: bx - 200, y: py, facing: 'right', hp: PLAYER.maxHp },
    boss: { ...state.boss, x: bx, y: py, facing: 'left', state: 'idle', stateElapsed: 0, currentAttack: null, hp: state.boss.maxHp },
    // スプライト runtime もリセット (検収 2026-07-06): 凍結直前の攻撃の汎用キー (telegraph 等=
    //   処刑人では退役済・未ロード) が currKey に残ると描画スキップ→ボスが透明になる。
    bossSprite: initBossSpriteRuntime(),
  }
  draw(ctx!, state)
}
// dev デバッグフック: パリィ報酬演出を静止描画 (体幹バー脈打ち+金粒+ボスのけぞり)。
//   postureRatio=体幹の満ち具合, flashAge=パリィからの経過秒。
;(window as any).__freezeReward = (postureRatio = 0.5, flashAge = 0.05, staggered = false) => {
  __frozen = true
  const bx = 620, py = ARENA.floorY
  state = {
    ...state,
    boss: {
      ...state.boss, x: bx, y: py, facing: 'left',
      posture: Math.max(0, Math.min(1, postureRatio)) * state.boss.maxPosture,
      state: staggered ? 'staggered' : state.boss.state,
    },
    player: { ...state.player, x: bx - 110, y: py, facing: 'right' },
    bossSprite: { ...state.bossSprite, parryOverlayRemainingSec: 0.22 * (1 - Math.min(1, flashAge / 0.22)) },
    fx: [{ kind: 'parry_spark', x: bx - 90, y: py - 110, t: state.time - flashAge, intensity: 1 }],
  }
  draw(ctx!, state)
}
// dev デバッグフック (2026-09-22 体幹の票 案A 検収): 弾いたのに自分が崩れた瞬間を静止描画。
//   look = now (白い成功の光) / a / b (b は画面の縁も締まる)。主人公は崩れ・体幹は満タン。
;(window as any).__freezeParryBreak = (age = 0.06, look: 'now' | 'a' | 'b' | 'c' | 'ab' = 'ab') => {
  __frozen = true
  const bx = 620, py = ARENA.floorY
  const t0 = state.time - age
  const fx: FxEvent[] = look === 'now'
    ? [{ kind: 'parry_spark', x: bx - 90, y: py - 110, t: t0, intensity: 1, isJust: false }]
    : [{ kind: 'parry_break', x: bx - 90, y: py - 110, t: t0, dir: 1 }]
  setParryBreakLook(look)
  if (look === 'b') fx.push({ kind: 'damage_vignette', t: t0 })
  state = {
    ...state,
    boss: { ...state.boss, x: bx, y: py, facing: 'left' },
    player: { ...state.player, x: bx - 110, y: py, facing: 'right', posture: playerMaxPosture(),
      state: 'stunned', stateElapsed: age },
    fx,
  }
  draw(ctx!, state)
}
// dev デバッグフック (P4 §6.1 検収): 連続弾きの段(parryChain)を注入して報酬演出を静止描画。
//   __freezeReward と同じ画だが player.parryChain を差し込み、 火花 intensity も hits.ts と同じ chainBoost でスケール。
//   render の escal は state.player.parryChain を直読みするので HUD バー pop もこれで段差が出る。
;(window as any).__freezeRewardChain = (postureRatio = 0.8, flashAge = 0.05, parryChain = 1) => {
  __frozen = true
  const bx = 620, py = ARENA.floorY
  const chain = Math.max(1, Math.min(COMBAT.parryChain.cap, parryChain))
  const chainBoost = 1 + (chain - 1) * COMBAT.parryChain.sparkBoostPerStep
  const intensity = Math.min(COMBAT.parryChain.sparkIntensityMax, 1 * chainBoost)
  state = {
    ...state,
    boss: {
      ...state.boss, x: bx, y: py, facing: ('left' as const),
      posture: Math.max(0, Math.min(1, postureRatio)) * state.boss.maxPosture,
    },
    player: { ...state.player, x: bx - 110, y: py, facing: ('right' as const), parryChain: chain },
    bossSprite: { ...state.bossSprite, parryOverlayRemainingSec: 0.22 * (1 - Math.min(1, flashAge / 0.22)) },
    fx: [{ kind: ('parry_spark' as const), x: bx - 90, y: py - 110, t: state.time - flashAge, intensity }],
  }
  draw(ctx!, state)
}
// 🌀💨 dev プレビュー: 今のボス(dream-hound)は見切り判定が無いので J/N で実機の音場で試聴。
//   J=見切り(perfect_dodge) / N=回避(dodge)。 M はカメラ余白の切替に使う (2026-08-02)。
window.addEventListener('keydown', (ev) => {
  if (ev.key === 'j' || ev.key === 'J') { ensureAudio(); playSfx('perfect_dodge'); showToast('🌀 見切り(プレビュー)') }
  else if (ev.key === 'n' || ev.key === 'N') { ensureAudio(); playSfx('dodge'); showToast('💨 回避(プレビュー)') }
})
// 🐢 キーポーズ検収ツール (花嫁の枚数判断用)。
//   O   = スロー再生を 1 → 0.35 → 0.15 で循環 (実戦の本物の動きをゆっくり見る=補間の滑らかさ/気持ちよさ)。
//   [ ] = ヴェール一閃を静止コマ送り (phase 0=溜め始め..2=当たり終わり)。1コマずつ送り「どこにポーズがあるか/隙間か」を数える。
//   \   = コマ送りを解除して通常プレイへ戻る。
const SLOW_LEVELS = [1, 0.35, 0.15]
;(window as any).__devSlow = 1
let __scrubPhase = 1.0
window.addEventListener('keydown', (ev) => {
  if (ev.key === 'o' || ev.key === 'O') {
    const cur = (window as any).__devSlow ?? 1
    const next = SLOW_LEVELS[(SLOW_LEVELS.indexOf(cur) + 1) % SLOW_LEVELS.length] ?? 1
    ;(window as any).__devSlow = next
    showToast('🐢 スロー: ' + (next === 1 ? '通常' : '×' + next))
  } else if (ev.key === '[' || ev.key === ']') {
    __scrubPhase = Math.max(0, Math.min(2, __scrubPhase + (ev.key === ']' ? 0.1 : -0.1)))
    ;(window as any).__freezeBossAttack('veilSweep', __scrubPhase)
    const lbl = __scrubPhase <= 1 ? '溜め' : '当たり'
    showToast('🎞 コマ送り veilSweep phase=' + __scrubPhase.toFixed(1) + ' (' + lbl + ')  [/]=送り \\=解除')
  } else if (ev.key === '\\') {
    __frozen = false
    showToast('▶ コマ送り解除')
  } else if (ev.key === 'h' || ev.key === 'H') {
    // 裁定D: 判定ボックス可視化トグル。 攻撃ごとに「判定が絵のどこまで届くか」を見て間合いを詰める場。
    const on = !((window as any).__showHitboxes)
    ;(window as any).__showHitboxes = on
    showToast('🧰 判定ボックス: ' + (on ? 'ON (青=弾ける/赤=弾けない/黄=まだ無効[予告ゾーン or contact前])' : 'OFF'))
  } else if (ev.key === 'g' || ev.key === 'G') {
    // 数値研究用 god mode: 無敵。 体幹/パリィ経済を死なずに観察するため。
    //   実際の固定 (hp 上書き) は frame ループ側で毎フレーム行う。
    const on = !((window as any).__godMode)
    ;(window as any).__godMode = on
    showToast('🛡 god mode (数値研究): ' + (on ? 'ON (無敵)' : 'OFF'))
  }
})

// 🎚 崩れ (致命可能) の合図を**プレイ中に触って決める**ツマミ (2026-07-27)。
//   体感で決まる値は静止画やGIFでは判定できない = ユーザー本人が触って決める場を作る。
//   0/1/2/3 = 舞台照明の絞り (切 / 浅い / 標準 / 深い)  ・  4 = 致命可能の音 on/off
//   ⚠️ 描画と音の設定しか変えない。 戦闘状態 (体幹・HP・判定・時間) には一切触らない。
//   ⚠️ 数字キーはゲーム操作に未割り当て (input.ts keyToAction を確認済み)。 DEVのみ。
const SPOT_LABEL = ['切 (変更前と同じ)', '① 浅い', '② 標準', '③ 深い']
// ✅ 既定 = ③ 深い (2026-07-27 ユーザー実機裁定)。 キーは残す = 後から戻せる形を保つ。
;(window as any).__spotLevel = 3
;(window as any).__fatalReadySfx = true
// ⚠️ 幕票の形の比較切替 (旧 `5` キー / `__lampStyle`) は 2026-07-28 に撤去。
//    ユーザー実機比較で「丸」に確定したため (灯・刻みは「世界観から浮く」で却下)。
//    復元は commit `3b65de0` の main.ts / render.ts を参照。
window.addEventListener('keydown', (ev) => {
  if (ev.key === '0' || ev.key === '1' || ev.key === '2' || ev.key === '3') {
    const lv = Number(ev.key)
    ;(window as any).__spotLevel = lv
    showToast('🎚 崩れの暗さ: ' + SPOT_LABEL[lv] + '   [0/1/2/3で切替  4=音]')
  } else if (ev.key === '4') {
    const on = !((window as any).__fatalReadySfx ?? true)
    ;(window as any).__fatalReadySfx = on
    ensureAudio()
    showToast('🔔 致命可能の音: ' + (on ? 'あり (崩れ中に2回)' : 'なし')
      + '   [0/1/2/3=暗さ  4=音]')
  }
})

// 🎥 舞台を広げてカメラで追う (2026-07-27・カメラ検討)。
//   C = 広さを循環 (切 → 1.4倍)。 M = カメラ余白を 480 → 360 → 240px で循環。
//   **切 = 変更前と 1px も変わらない状態**。
//   ⚠️ 1.8倍は右端に絵の無い平坦な帯が出るため、現素材では選べない。
//   ⚠️ C/M はゲーム操作に未割り当て (input.ts keyToAction を確認済み)。 DEVのみ = 配布版に出ない。
// 2026-07-28: 騎士の新背景 knight-hall-v2.png は世界1608pxぶんしかなく、舞台1.4倍の世界(1940px)を
//   覆えない (覆う絵に必要な3.59:1は画像生成の上限3:1を超える)。 1.4倍を畳んで [1] だけにする
//   (knight-hall-v2 統合票 §3-4)。 配列と仕組みは残すので、別の横長素材ができたら戻せる。
// 🔴 2026-08-02 解除: カメラ余白を240へ下げれば騎士は現行背景で覆える（票参照）。
const STAGE_MULS = [1, 1.4]
let __stageLevel = 0
;(window as any).__setStageWidth = (level: number) => {
  __stageLevel = Math.max(0, Math.min(STAGE_MULS.length - 1, Math.round(level)))
  setArenaWidthMul(STAGE_MULS[__stageLevel]!)
  setCameraEnabled(__stageLevel > 0)
  return { level: __stageLevel, mul: STAGE_MULS[__stageLevel], camera: __stageLevel > 0 }
}
window.addEventListener('keydown', (ev) => {
  if (ev.key === 'b' || ev.key === 'B') {
    // ボスの「芯」(2026-07-27)。2026-09-18 採用で既定は「なし」(全部すり抜け)。B で旧・芯ありと比べられる。
    const on = !isBossCore()
    setBossCore(on)
    showToast('🧍 ボスの芯: ' + (on ? 'あり (旧: 歩きは止まる・回避で抜ける)' : 'なし (採用: 歩きも回避も通り抜け)')
      + '   [B で切替]')
  }
  if (ev.key === 'c' || ev.key === 'C') {
    __stageLevel = (__stageLevel + 1) % STAGE_MULS.length
    setArenaWidthMul(STAGE_MULS[__stageLevel]!)
    setCameraEnabled(__stageLevel > 0)
    showToast('🎥 舞台: ' + (__stageLevel === 0 ? '切' : '1.4倍') + '（カメラ余白 ' + getCameraMarginPx() + 'px）')
  }
  if (ev.key === 'm' || ev.key === 'M') {
    const margins = [480, 360, 240]
    const current = getCameraMarginPx()
    const next = margins[(margins.indexOf(current) + 1) % margins.length]!
    setCameraMarginPx(next)
    const world = worldBoundsFor('vigil-knight')
    showToast('📐 カメラ余白: ' + next + 'px（世界幅 ' + (world.right - world.left) + 'px / 絵 1608px）')
  }
  // 🔴 2026-07-28: C (舞台の広さ) と V (カメラだけON) を撤去した。
  //   舞台1.4倍を畳んだので C は循環先が無く、V は舞台1倍のままカメラだけ有効にするため
  //   worldBoundsFor が画面より広い世界(1660px)を返し、背景の引き伸ばし経路が
  //   絵を横1380pxへ伸ばして**画を壊す**。 押せる状態で残す意味が無い。
  // 🔴 2026-08-02 解除: C は可変カメラ余白で再開。V は今回も戻さない。
})

// 🔍 画面の寄せ (2026-10-18・src/cam_zoom.ts)。 作者「主人公含めて全体的に画面に対して小さいね」→「全員を同じ比率で大きくしたい」の比較版。
//   配布版は 1.3 倍 (CAM_ZOOM_DEFAULT)。 ?camZoom=1 = 旧の見え方 (等倍)・?camZoom=1.15|1.45 = 他の段・?camZoomFit=0 = 二人が離れても引かない版。
//   Z = 1 → 1.15 → 1.3 → 1.45 を循環。 __setCamZoom(z) は撮影用。 DEV だけ = 配布版に出ない。
//   案C (10-18・配布版の既定): 名乗りと決着は等倍・上へ出る物で引く。 ?camZoomScene=0 / __setCamZoomScene(false) で切る (横だけを見る前の寄せ方)。
if (import.meta.env.DEV) {
  readCamZoomFromUrl(window.location.search)
  ;(window as any).__setCamZoom = (z: number) => setCamZoom(z)
  ;(window as any).__setCamZoomScene = (on: boolean) => setCamZoomScene(on)
  ;(window as any).__camZoomNow = () => camZoomView().z
  // 撮影用 (scripts/capture_cam_zoom.mjs): 今のコマを止めて段 z で描き直す = 同じ場面を段ごとに並べる。 null で再開 (等倍へ戻す)。
  ;(window as any).__camZoomSnap = (z: number | null) => {
    if (z === null) { setCamZoom(CAM_ZOOM_DEFAULT); __frozen = false; return }
    __frozen = true
    setCamZoom(z)
    draw(ctx!, state)
  }
  window.addEventListener('keydown', (ev) => {
    if (ev.code !== 'KeyZ' || ev.repeat) return
    const z = cycleCamZoom()
    showToast('🔍 画面の寄せ: ' + (z === 1 ? '等倍 (旧)' : z + ' 倍' + (z === CAM_ZOOM_DEFAULT ? ' (配布版)' : '')) + (camZoomFit() ? '' : '（離れても引かない）') + '   [Z で切替]')
  })
}

// Codex内ブラウザなど、検収用タブから指定ボスへ直接入る入口。
// devサーバー限定なので通常ビルドのゲーム進行や保存データには影響しない。
const directBossId = new URLSearchParams(window.location.search).get('boss')
if (directBossId) {
  ;(window as any).__setBoss(directBossId)
  preloadBossSprites(state.boss.id)
}

// メニュー当たり矩形の可視化 (?menuHit=1)。 見えている位置と押せる位置がズレていないかの
//   実表示確認専用 (2026-07-25 第2段 §7-4)。 devサーバー限定・本番ビルドには影響しない。
if (new URLSearchParams(window.location.search).get('menuHit') === '1') {
  ;(window as any).__showMenuHitboxes = true
}
// ⚔ 致命を弾ける仕組み (10-09 に作り・10-10 配布版の既定・src/exec_parry.ts)。検収パック kensyu-exec-parry.html が使う。
//   __setExecParry('off'|'on') = 戦いを止めずに切り替える (URL の ?execParry= と同じ中身・off = 旧 (弾けない)・それ以外 = 既定)。
//   __execStunNow() / U キー = いま崩れる (体幹を満タンにして崩れへ・わざと致命を受けるため)。
;(window as any).__setExecParry = (m: string) => {
  const v = setExecParryMode(m)
  showToast('⚔ 致命の弾き: ' + (v === 'off' ? '旧 (弾けない)' : '既定 (パリィで弾ける)'))
  return v
}
//   __setExecPush('old'|'new'|'sekiro') = 弾いた時の押し戻しを切り替える (URL の ?execPush= と同じ中身・10-09 夜)。
;(window as any).__setExecPush = (m: string) => {
  const v = setExecPushVersion(m)
  showToast('⚔ 押し戻し: ' + (v === 'old' ? '前の版' : v === 'new' ? '新しい版 (遠くへ・踏ん張る)' : 'SEKIRO 寄り (少しだけ)'))
  return v
}
;(window as any).__setExecPushWeight = (m: string) => {
  //   __setExecPushWeight('off'|'a'|'b'|'c') = 押し戻しの重さ (カメラの寄り・フラッシュ・揺れ・止め) を切り替える (URL の ?execPushWeight= と同じ中身・10-09 夜)。
  const v = setPushWeight(m)
  showToast('⚔ 押し戻しの重さ: ' + (v === 'off' ? '重ねない (new だけ)' : v === 'a' ? 'a 寄って止める' : v === 'b' ? 'b 白く飛ばして沈む' : 'c ボスの重さで段 (既定)'))
  return v
}
;(window as any).__setExecParryFx = (m: string) => {
  //   __setExecParryFx('new'|'grayNow'|'grayMid'|'grayShort'|'b1014'|'old') = 致命を弾いた時の演出を切り替える (URL の ?execParryFx= と同じ中身・10-14／1014c)。
  const v = setExecParryFx(m)
  showToast('⚔ 致命を弾いた演出: ' + execParryFxLabel())
  return v
}
;(window as any).__execStunNow = (opts?: { clearHits?: boolean }) => {
  if (state.phase !== 'playing') return false
  const s = state.player.state
  if (s === 'executing' || s === 'grabbed' || s === 'stunned') return false
  state = { ...state, player: stunPlayer({ ...state.player, posture: playerMaxPosture(), knockbackRemainingPx: 0, execPush: undefined }),
    // 撮影用: 前の技の床・飛び道具を消して、致命だけを見せる (検収パックは消さない=実戦と同じ)。
    ...(opts?.clearHits ? { hits: [] } : null) }
  showToast('💫 崩れた (致命が来る・' + (execParryMode() === 'off' ? '旧・弾けない' : 'パリィで弾ける') + ')')
  return true
}
window.addEventListener('keydown', (ev) => {
  if (ev.code !== 'KeyU' || ev.repeat) return
  ;(window as any).__execStunNow()
})
// 敗北画面の全タイムラインを実機で決めるツマミ。K で全時刻の倍率を一緒に動かす。
;(window as any).__defeatOverlayTimingScale = 1
window.addEventListener('keydown', (ev) => {
  if (ev.code !== 'KeyK' || ev.repeat) return
  const levels = DEFEAT_OVERLAY_TIMING_SEC.devScaleCycle
  const current = (window as any).__defeatOverlayTimingScale as number
  const currentIndex = levels.findIndex((value) => value === current)
  const next = levels[(currentIndex + 1) % levels.length] ?? 1
  ;(window as any).__defeatOverlayTimingScale = next
  const freshGateSec = defeatRetryGateSec({
    deaths: 1,
    showDifficultyHint: false,
    hasNotice: false,
  }, DEFEAT_OVERLAY_TIMING_SEC, next)
  showToast(`🎭 敗北タイミング: ×${next} / 心得だけ ${freshGateSec.toFixed(2)}秒`)
})
function showToast(msg: string): void {
  let el = document.getElementById('__toast') as HTMLDivElement | null
  if (!el) {
    el = document.createElement('div')
    el.id = '__toast'
    el.style.cssText = 'position:fixed;left:50%;top:24px;transform:translateX(-50%);z-index:9999;' +
      'background:rgba(20,16,28,0.92);color:#e8d8ff;padding:10px 18px;border:1px solid #6a52a0;' +
      'border-radius:8px;font:600 15px/1 "Segoe UI",system-ui,sans-serif;letter-spacing:0.04em;' +
      'pointer-events:none;transition:opacity 0.3s;box-shadow:0 0 24px rgba(120,90,200,0.3);'
    document.body.appendChild(el)
  }
  el.textContent = msg
  el.style.opacity = '1'
  window.clearTimeout((showToast as any)._tid)
  ;(showToast as any)._tid = window.setTimeout(() => { if (el) el.style.opacity = '0' }, 1400)
}
// 📝 試遊の記録 (2026-09-27)。 戦闘中の動き・入力・受けの結果を playlogs/<日付>/ へ自動保存する。
//   記録するのは検収パック (kensyu*.html) の iframe の中か ?playlog=1 の時だけ (それ以外は null = 何もしない)。
//   F (パッドは △/Y) = 後から付ける栞 (前12秒・後2秒を AI が読む)。 読み方 = docs/ai/playlog.md。
//   見るだけ = 戦闘状態は1バイトも書き換えない。 dev サーバーの /__playlog へ送る (配布版に無い)。
const __playlogRecorder = installPlaylog({
  dev: true,
  toast: showToast,
  meta: () => ({ buildId: __BUILD_ID__, buildDate: __BUILD_DATE__ }),
})
;(window as any).__playlog = {
  mark: () => __playlogRecorder?.mark('api'),
  flush: () => __playlogRecorder?.flush(false),
  file: () => __playlogRecorder?.currentFile ?? null,
  recording: __playlogRecorder !== null,
}
} // end if (import.meta.env.DEV) — 本番には含めない

// ?kiroku で開くと「遊んだ記録を写す」ボタンを出す (途中でやめた友達に1回押してもらう用)。
if (new URLSearchParams(location.search).has('kiroku')) mountRecordCopyButton(__BUILD_ID__)
// 試遊の記録を作者へ送る (配布版・初回に聞いて同意した人だけ＝src/playtest_upload.ts)
// Steam 版は送る案内も送信も出さない (2026-10-31 作者の答え feedback=hide・docs/ledger/project.md)。
const STEAM_BUILD = import.meta.env.MODE === 'steam'
if (!advPreview && !STEAM_BUILD) installPlaytestUpload(__BUILD_ID__, import.meta.env.DEV)
// Steam 版: 記録にある実績を Steam へ渡し直す (オフラインで解いた分・src/achievements.ts)。
if (STEAM_BUILD) syncAchievementsToSteam(loadRecord())

let lastBgmPath: string | null = null
let lastSpriteBossId = state.boss.id
let lastPrefetchBossId: string | null = null
let lastHudBossId: string | null = null
let tipsArtPrefetched = false
const prefetchNextOn = !import.meta.env.DEV || prefetchNextEnabled(window.location.search)
// 会話場面から戦いへ抜ける暗転を、ボスの絵と主人公の Spine が読み終わるまで延ばす (src/battle_asset_gate.ts・11-01)。
//   開発版の ?assetGate=off で入れる前 (暗転 1.2 秒で必ず戦いへ)。
//   11-02: 部屋の背景も待ち、会話場面の頭も最初の絵 (先代の回想を含む場面は回想の4枚も) が読めるまで黒のまま延ばす。
//   11-03: ボスの FX・技の音も待つ。会話場面を通らずに戦いへ入る時も同じ判定で待つ (game.ts battleEntryWaitMs)。
//   開発版の ?assetGate=boss で 11-02 より前 (ボスの絵と Spine だけ・会話場面の頭は待たない)。
const assetGateMode = import.meta.env.DEV ? new URLSearchParams(window.location.search).get('assetGate') : null
if (assetGateMode !== 'off') {
  const withRoom = assetGateMode !== 'boss'
  // 11-03: そのボスの FX・技の音 (読む順番の列 src/asset_queue.ts でボスの番に読む) も待つ。
  setBattleAssetsReadyCheck((id) => bossSpritesSettled(id) && isSpinePlayerLoaded() && (!withRoom || roomBackgroundSettled(id))
    && (!withRoom || assetQueue.pendingFor(id) === 0))
  if (withRoom) {
    setAdvAssetsReadyCheck((scene) => advSceneHeadSettled(scene) && (!advSceneHasFlashback(scene) || flashbackImagesSettled()))
  }
}
// 致命可能の合図を置く時刻 (崩れ開始からのms)。 0ms は崩し音自体が鳴っているので置かない。
const FATAL_READY_BEATS_MS = [380, 860]
let fatalReadyBeatsDone = 0
let lastFinisherActive = false
let lastAdvExiting = false   // 戦う前の場面から戦いへ抜ける間 (state.adv.exitMs)
let lastPhase = state.phase
let lastTime = performance.now() / 1000
let accumulator = 0
const MAX_FRAME_DT = 0.25
const hintEl = document.querySelector<HTMLElement>('.hint')
let bootLampEl = document.getElementById('boot-lamp')

function frame(nowMs: number): void {
  if (__frozen) { requestAnimationFrame(frame); return }
  const now = nowMs / 1000
  const frameDt = Math.min(MAX_FRAME_DT, now - lastTime)
  lastTime = now
  // 致命を弾いた後のゆっくりの間に攻撃・パリィ・回避が押されたら、次の更新を待たずに普通の速さへ戻す
  //   (1014c・A-3「少しもたつく」。0.25 倍だと次の更新まで最大 4 コマ待つため。game.ts の更新でも同じ判定をする)。
  if (state.timeScale < 1 && state.phase === 'playing' && !state.finisher && !state.deathBeat && state.hitStopRemaining <= 0
    && hasBufferedAction(EXEC_SLOW_CUT_ACTIONS) && execSlowCutNow(state.fx, state.time)) {
    state = { ...state, timeScale: execSlowTimeScale(state.fx, state.time, 0) }
  }
  // DEV: スロー再生倍率 (O キーで循環)。 本番は tree-shake で *1。
  accumulator += frameDt * state.timeScale * (import.meta.env.DEV ? ((window as any).__devSlow ?? 1) : 1)
  // 覚醒王の戦いの間だけ舞台 1.4 倍＋カメラ (src/awoken_wide_stage.ts・配布版・旧は開発版 ?awokenStage=narrow)。
  {
    const wide = syncAwokenWideStage(state.boss?.id)
    if (wide) setCameraEnabled(wide === 'apply')
  }

  let safety = 8
  while (accumulator >= FIXED_DT && safety > 0) {
    const hitStopBeforeUpdate = state.hitStopRemaining
    // DEV: 外から入力を差し込む (2026-10-02 AI の遊び点検＝scripts/fresh_eyes_capture.mjs の bot 用)。
    //   window.__botInput = (state) => Input。未設定なら従来どおりキーボード/パッド。
    const botInput = import.meta.env.DEV ? (window as any).__botInput : undefined
    // ストップ中 (この更新が game.ts のヒットストップの早期 return に入る間) は押しの寿命を止める (既定・配布版も。旧は DEV ?hitstopBuffer=off)。
    setInputBufferAgingFrozen(bufferAgeHeldInHitstop && state.hitStopRemaining > 0)
    // 作者の割り当て (キー設定) が効くのは戦闘中だけ。 メニュー・物語・幕間は既定の操作のまま (src/key_bindings.ts)。
    setInputUiMode(state.phase !== 'playing' || state.paused)
    const raw = botInput ? botInput(state) : readInput()
    // 感想欄の出口ボタン = 進行入力として1tickだけ流す (遷移規則は game.ts が持つ)。
    //
    // 🔴 2026-07-28 修正: 以前は 'retry' だけを流していた。 ところが game.ts の confirmPressed は
    //    **パッドの時しか 'retry' を決定として見ない** (2026-07-26 の「kbmのR/Enterは決定に効かない」裁定)。
    //    = マウス/キーボードで遊んでいる人には、 この出口ボタンが押しても何も起きなかった。
    //    実測 (dev + Playwright): tsuzukuNote でクリック → phase は tsuzukuNote のまま。
    //    パッドを持っていない友達は、 配布版の最後で出口が無い画面に取り残されていた。
    //    どちらの機器でも通るよう、 両方の決定キーを流す。
    const advanced = consumeFeedbackClose()
      ? { ...raw, pressed: new Set([...raw.pressed, ...FEEDBACK_CLOSE_KEYS]) }
      : raw
    // 幕間ADVの選択肢が出ている時だけ矩形を載せる。 ctx を持つのは main.ts だけなので
    //   ここが計測の置き場所として正しい (2026-07-25 第4段・票 §5-1)。
    const input = { ...advanced, advChoiceRects: measureAdvChoiceRectsForInput(ctx!, state) }
    const stateBeforeTick = state
    // A finished after-scene uses the same continue gate as preBattle, avoiding
    // campaign progression/persistence entirely when leaving the preview.
    const previewAfterDone = advPreview && state.phase === 'interlude' && !!state.adv?.done
    state = updateGame(
      previewAfterDone ? { ...state, phase: 'preBattle' } : state,
      input,
      import.meta.env.DEV ? (window as any).__defeatOverlayTimingScale : undefined,
    )
    if (advPreview) {
      if (state.phase === 'playing') {
        if (stateBeforeTick.phase === 'preBattle') {
          const scene = getInterludeScene(advPreviewId!)
          state = { ...stateBeforeTick, phase: 'interlude', adv: startScene(scene), phaseElapsedSec: 0, sfx: [], fx: [] }
        } else state = restartAdvPreview()
      } else {
        state = { ...state, phase: stateBeforeTick.phase, campaign: stateBeforeTick.campaign }
      }
    }
    if (state.adv && state.adv.sceneId !== stateBeforeTick.adv?.sceneId) {
      const scene = state.phase === 'preBattle' ? getPreBattleScene(state.boss.id, state.campaign) : getInterludeScene(state.boss.id)
      if (scene && isPictureScene(scene)) preloadAdvPictures(scene)
    }
    // 試遊の足あと (配布版も・見るだけ・この端末の localStorage だけ。 src/playtest_record.ts)。
    if (!advPreview) {
      playtestTick(stateBeforeTick, state, FIXED_DT * 1000, __BUILD_ID__)
      playtestUploadTick(stateBeforeTick, state, raw)
    }
    // 試遊の記録 (DEV のみ・見るだけ)。 god mode の HP 上書きより前に読む = 実際に受けた量が残る。
    if (import.meta.env.DEV) {
      playlogTick(stateBeforeTick, state, raw, { god: !!(window as any).__godMode, slow: (window as any).__devSlow ?? 1 })
    }
    // Retrying the review battle should return to the cannon candidate, not room 1 blade art.
    if (cannonFajinReview && state.phase === 'playing' && state.boss.id === 'the-executioner'
      && state.boss.exec && state.boss.executesTaken === 0) {
      state = { ...state, boss: { ...state.boss, executesTaken: 1,
        exec: { ...state.boss.exec, held: 'cannon', morph: 'no', morphElapsedMs: 0 } } }
    }
    if (import.meta.env.DEV && (window as any).__godMode) {
      // 数値研究用 god mode (G キー): 無敵。 毎tick 上書き。 本番は tree-shake。
      state = { ...state, player: { ...state.player, hp: PLAYER.maxHp } }
    }
    if (state.sfx.length > 0 && state.settings.seOn) {
      // パリィ音の強度とジャスト判定 = 同時に出る parry_spark FX から取得 (映像/揺れ/hitStop と同値)。
      let parryIntensity = 1
      let parryIsJust = false
      let parryIsExec = false
      let parryPitch: ParryPitchHit | undefined
      if (state.sfx.includes('parry')) {
        // 崩した瞬間の見た目 (DEV ?parryDownFx=z) では parry_spark の代わりに parry_down が出る = どちらか新しい方を見る。
        const spark = [...state.fx].reverse().find((f) => f.kind === 'parry_spark' || f.kind === 'parry_down')
        if (spark && spark.kind === 'parry_spark') {
          if (typeof spark.intensity === 'number') parryIntensity = spark.intensity
          parryIsJust = spark.isJust ?? false
          parryIsExec = spark.exec ?? false   // ボスの致命を弾いた (音の候補 ?execParrySound= の切り替え・src/parry_sound.ts)
          parryPitch = { chain: spark.chain ?? 1, weight: spark.weight ?? Math.min(1, parryIntensity), broke: spark.broke ?? false, attackId: spark.attackId }
        } else if (spark && spark.kind === 'parry_down') {
          parryIsJust = true
          parryPitch = { chain: spark.chain ?? 1, weight: spark.weight ?? 1, broke: true, attackId: spark.attackId }
        }
      }
      // 連続の段と技の重さ (parryPitch) は音の候補 ?parryPitch= だけが使う (src/parry_pitch.ts・選んでいなければ今の音)。
      playPending(state.sfx, parryIntensity, parryIsJust, parryIsExec, parryPitch)
    }
    const presentation = finishFixedStepForPresentation(
      accumulator,
      hitStopBeforeUpdate,
      state.hitStopRemaining,
    )
    accumulator = presentation.accumulator
    safety -= 1
    // DEV: 進んだ tick の数 (撮影が 1/60 秒ずつのコマを取りこぼさず数えるため・scripts/capture_exec_unique_polish.mjs)。
    if (import.meta.env.DEV) (window as any).__tickCount = ((window as any).__tickCount ?? 0) + 1
    // DEV: その tick で鳴った音を撮影へ渡す (1 回の描画の間に 2 tick 進んでも取りこぼさない・scripts/capture_exec_unique_sfx.mjs)。
    if (import.meta.env.DEV) (window as any).__sfxTap?.((window as any).__tickCount, state.sfx, state.fx)
    // 命中tickの後に蓄積分を続けて処理すると、短いhit stopが最初の描画前に消費される。
    // 接触姿勢を必ず一度提示し、残りの停止時間は次の実フレームから数える。
    if (presentation.shouldYieldForDraw) break
  }

  // 致命が入れられる「間」の合図 (2026-07-27・友達FB 3-2)。
  //   崩し音の中の合図は崩れた**瞬間**の1発だけなので、 鳴った時に別を見ていたら以後は無音になる。
  //   窓は BOSS.staggerMs=1400ms の**状態**なので、 その間の 380ms / 860ms に薄く2回だけ置く。
  //   ⚠️ 鳴らし続けない (パリィは1戦で何十回も出る = 持続音は必ず疲れる)。
  //   dev では __fatalReadySfx=false で切れる (暗さの判定と音の判定を分けるため)。
  {
    const st = state.boss.state === 'staggered' ? state.boss.stateElapsed * 1000 : -1
    const on = state.settings.seOn
      && (!import.meta.env.DEV || ((window as any).__fatalReadySfx ?? true))
    if (st < 0) { fatalReadyBeatsDone = 0 }
    else if (on) {
      for (const [i, at] of FATAL_READY_BEATS_MS.entries()) {
        if (fatalReadyBeatsDone <= i && st >= at) {
          playSfx('fatal_ready')
          fatalReadyBeatsDone = i + 1
        }
      }
    } else { fatalReadyBeatsDone = FATAL_READY_BEATS_MS.length }
  }

  // 致命 (finisher) に入った瞬間、 戦闘BGMをフェードアウト開始。
  //   致命シーケンス(実時間~3.6s)中に消え、 最後の静寂ビート(余韻1.6s)は無音、
  //   VICTORY が出る頃には消えている。
  const finisherActive = state.finisher != null
  if (finisherActive && !lastFinisherActive) {
    fadeOutBgm()
  }
  lastFinisherActive = finisherActive

  // 戦う前の場面から戦いへ抜ける間 (2026-10-28 作者「戦闘への移行時にBGMはフェードアウトさせて、それから戦闘画面に移行してほしい」)。
  //   遠くの曲を消しきってから戦いへ入り、 戦いの曲は頭から鳴らし直す (lastBgmPath を外して次の playBgmPath を通す)。
  const advExiting = state.adv?.exitMs != null
  if (advExiting && !lastAdvExiting) {
    fadeOutBgm((ADV_BATTLE_EXIT_MS * 0.9) / 1000)
    lastBgmPath = '__advExit'
  }
  lastAdvExiting = advExiting

  // フェーズ駆動 BGM: あるべき曲が変わった時だけクロスフェード。
  //   finisher 中は専用フェードに任せて変更しない (lastBgmPath 据え置き → 次フェーズで正しく切替)。
  // 会話場面の曲の遠さ。 曲を切り替える前に決めておき、 新しい曲が最初から遠くで鳴るようにする。
  {
    const advScene = !state.adv ? null
      : state.phase === 'preBattle' ? getPreBattleScene(state.boss.id, state.campaign)
      : state.phase === 'interlude' ? getInterludeScene(state.boss.id) : null
    if (advScene && state.adv) {
      setBgmMix(ADV_BGM_FAR_LEVEL, true, 1)
    } else setBgmMix(1, false, 1.2)
  }
  if (!finisherActive && !advExiting) {
    const want = desiredBgmPath(state)
    if (want !== lastBgmPath) {
      playBgmPath(want)
      lastBgmPath = want
    }
    setBgmRate(desiredBgmRate(state))   // 最終部屋の転調 (同値は no-op)
  }
  // 会話場面の環境音 (src/adv.ts advAmbience): 場面の外・効果音オフでは止める (同じ id は no-op)。
  {
    const ambScene = !state.adv || !state.settings.seOn ? null
      : state.phase === 'preBattle' ? getPreBattleScene(state.boss.id, state.campaign)
      : state.phase === 'interlude' ? getInterludeScene(state.boss.id) : null
    const amb = ambScene && state.adv && !advExiting ? advAmbience(state.adv, ambScene) : null
    setAdvAmbience(amb?.id ?? null, amb?.fadeMs ?? (advExiting ? ADV_BATTLE_EXIT_MS * 0.9 : 400))
  }
  // 読む順番の的: いまのボス・次のボス (幕間と勝った後は次のボスも急ぐ)。
  assetQueue.setFocus({ current: state.boss.id, next: state.solo ? null : nextCampaignBossId(state.campaign),
    nextIsNear: state.phase === 'interlude' || state.phase === 'victory' })
  // ボスの HUD の枠も先に読む (一戦だけ ?fight= の時も・11-04 src/boss_hud_view.ts preloadBossHud)。
  if (state.boss.id !== lastHudBossId) { preloadBossHud(state.boss.id); lastHudBossId = state.boss.id }
  if (state.boss.id !== lastSpriteBossId) {
    preloadBossSprites(state.boss.id)
    warmCurrentBossArt(state.boss.id)
    lastSpriteBossId = state.boss.id
  }
  // 次の一戦の絵をいまの一戦の間に読む (src/prefetch_next.ts)。起動直後の最初のボスでも1回走るよう別に覚える。
  if (state.boss.id !== lastPrefetchBossId && !state.solo && !advPreview && prefetchNextOn) {
    lastPrefetchBossId = state.boss.id
    const interlude = getInterludeScene(state.boss.id)
    if (isPictureScene(interlude)) preloadAdvPictures(interlude)
    // いまのボスの最初の戦闘前の会話場面 (タイトルで読み始める・プロローグなど)・部屋の背景・回想。
    const own = getPreBattleScene(state.boss.id, state.campaign)
    if (own && isPictureScene(own)) preloadAdvPictures(own)
    prefetchRoomBackground(state.boss.id)
    const nextId = nextCampaignBossId(state.campaign)
    if (state.boss.id === 'former-princess' || nextId === 'former-princess') prefetchFlashbackImages()
    if (nextId && nextId !== state.boss.id) {
      preloadBossSprites(nextId)
      prefetchRoomBackground(nextId)
      const pre = getPreBattleScene(nextId, advanceToNextBoss(state.campaign))
      if (pre && isPictureScene(pre)) preloadAdvPictures(pre)
    }
  }

  // 負け画面の小ネタの絵は、戦いが始まってから読む (ボスの絵・背景より後に回す)。
  if (state.phase === 'playing' && !tipsArtPrefetched && prefetchNextOn) { tipsArtPrefetched = true; prefetchTipsArt() }

  // phase 遷移でスティンガー (一発もの)。 勝利=終幕 (一礼して舞台袖へ) / 敗北。
  //   勝利時は finisher で戦闘BGMが既にフェード済 → VICTORY と同時に終幕が鳴る。
  //   敗北時は戦闘BGMがまだ鳴っているので畳んでから敗北スティンガー。
  if (state.phase !== lastPhase) {
    if (state.phase === 'victory' || state.phase === 'cleared') {
      playSting('/bgm/curtain-fall.mp3', 0.45)
    } else if (state.phase === 'defeat') {
      fadeOutBgm(0.8)
      playSting('/bgm/defeat.mp3', 0.4)
    }
    lastPhase = state.phase
  }

  if (!STEAM_BUILD || (window as any).steamBridge?.smoke) (window as any).__state = state   // Steam 版は smoke (自動確認) の時だけ覗き窓を出す
  if (hintEl) hintEl.style.display = state.phase === 'playing' ? 'none' : ''
  // 感想欄 = 実務カードの上にだけ出す DOM。 出し入れは状態が変わった時だけ働く。
  //   一戦だけモードは撃破画面に出す = そこが「遊び終えた瞬間」だから (2026-07-28)。
  //   ボタンは「もう一度戦う」へ変わり、押すと同じボスが立ち上がり直す (game.ts の restartSolo)。
  syncFeedbackPanel(
    !STEAM_BUILD && (state.solo ? state.phase === 'victory' : state.phase === 'tsuzukuNote'),
    state.solo
      ? buildSoloFeedbackContext(state.campaign, getDifficulty(), state.boss.id)
      : buildFeedbackContext(state.campaign, getDifficulty()),
  )
  // DEV: 描く重さを測る (scripts/measure_render_scale.mjs・案B 10-18)。 __drawProbe があれば draw の時間 (ms) を渡す。
  if (import.meta.env.DEV && (window as any).__drawProbe) {
    const t0 = performance.now()
    draw(ctx!, state)
    ;(window as any).__drawProbe(performance.now() - t0)
  } else draw(ctx!, state)
  if (bootLampEl) retireBootLamp()
  requestAnimationFrame(frame)
}

// 起動の灯 (index.html #boot-lamp・11-03) を最初の絵で退かす。タイトルの絵を待つ間は canvas が同じ所・同じ時計で常夜燈を描くので、すぐ外して引き継ぐ。
//   それ以外 (すぐ絵が出た時) は 250ms で消えていく (出かけた灯がぷつっと消えて見えないように)。
function retireBootLamp(): void {
  const el = bootLampEl!
  bootLampEl = null
  if (titleBootLampDrawnLastFrame()) { el.remove(); return }
  const a = getComputedStyle(el).opacity
  el.style.animation = 'none'
  el.style.opacity = a
  void el.offsetWidth
  el.style.transition = 'opacity 250ms ease-out'
  el.style.opacity = '0'
  setTimeout(() => el.remove(), 300)
}

// 同梱の字 (src/ui_font.ts) を読み終えてから最初の絵を描く (OS の字で描いてから替わる一瞬を出さない)。届かない時も 3 秒で始める。
void Promise.race([loadUiFont(), new Promise(r => setTimeout(r, 3000))]).then(() => requestAnimationFrame(frame))
